<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { defineVaStepperSteps, useModal, useToast, VaButton, VaIcon } from 'vuestic-ui'
import NewCustomer from '../../customers/pages/NewCustomer.vue'
import { getAllContacts } from '../../../core/requests/Contacts'
import { getAllServices } from '../../../core/requests/Services'
import { getAllVehicles } from '../../../core/requests/Vehicles'
import { getAllDrivers } from '../../../core/requests/Drivers'
import EditCustomer from '../../customers/pages/EditCustomer.vue'
import { getAllRoutes } from '../../../core/requests/Routes'
import { getAllExpenses } from '../../../core/requests/Expenses'
import InputAddress from '../components/InputAddress.vue'
import { newOportunity, sendQuotationToMail, updateQuotation } from '../../../core/requests/Oportunities'
import NewComment from '../components/NewComment.vue'
import Interactions from '../components/Interactions.vue'
import { validators } from '../../../services/utils'
import { useOportunitiesStore } from '../../../stores/oportunities-store'
import { storeToRefs } from 'pinia'
import moment from 'moment'
import _ from 'lodash'
import { onlyNumbers } from '../../../core/helpers'
import { newOrder } from '../../../core/requests/Orders'
import { useOrdersStore } from '../../../stores/orders-store'
import { useRouter } from 'vue-router'
import { HOST } from '../../../core/utils/constants'
import NewContract from '../../contracts/pages/NewContract.vue'
import { quotationHaveContract } from '../../../core/requests/Contracts'
import ViewContract from '../../contracts/pages/ViewContract.vue'
import NewRoute from '../../settings/NewRoute.vue'

const emit = defineEmits(['close'])
const props = defineProps(['data', 'detail'])
const vOnlyNumbers = onlyNumbers
const { notify } = useToast()
const oportunityStore = useOportunitiesStore()
const { statusOptions } = storeToRefs(oportunityStore)
const statuses = statusOptions.value.filter(
  (f: any) => f.label != 'Cotizado' && f.label != 'Borrador' && f.label != 'Enviado',
)
const isOnChangeStatus = ref(false)
const showNewComment = ref(false)
const loadingData = ref(true)
const step = ref(0)
const steps = ref(
  defineVaStepperSteps([
    {
      label: 'Contacto',
      icon: 'person_search',
      beforeLeave: (step) => {
        step.hasError = !selectedContacts.value?.length

        if (step.hasError) {
          notify({
            message: 'Debe seleccionar un contacto',
            color: 'danger',
            duration: 1000,
          })
        }
      },
    },
    {
      label: 'Servicios',
      icon: 'route',
      beforeLeave: (step) => {
        step.hasError = !selectedServices.value?.length

        if (step.hasError) {
          notify({
            message: 'Debe agregar un servicio',
            color: 'danger',
            duration: 1000,
          })
        }
      },
    },
    { label: 'Resumen', icon: 'verified' },
  ]),
)

const selectedCustomer: any = ref(null)
const showNewCustomer: any = ref(false)
const showViewCustomer: any = ref(false)
const contactSelected: any = ref(null)
const showNewContract: any = ref(null)
const showViewContract: any = ref(null)
const contacts: any = ref([])
const services: any = ref([])
const vehicles: any = ref([])
const expenses: any = ref([])
const drivers: any = ref([])
const routes: any = ref([])
const errors: any = ref([])
const selectedContacts: any = ref([])
const selectedServices: any = ref([])
const types = ref([
  {
    id: 1,
    label: 'Ida y vuelta',
  },
  {
    id: 2,
    label: 'Trayecto',
  },
  {
    id: 3,
    label: 'Por Horas',
  },
])
const selectedService: any = ref(null)
const clientsOpen: any = ref(false)
const servicesOpen: any = ref(true)
const confirSelected: any = ref(null)
const contractId: any = ref(null)
const quotation: any = ref({
  title: '',
})
const showConfirm: any = ref(false)
const confirmProcess: any = ref(false)
const activeDetailTab: any = ref(0)
const _noedit = computed(() => props.detail !== undefined)
const _withSerie = computed(() => !!props.data?.serie)
const _contacts: any = computed({
  get: () => {
    const filtered: any = []
    contacts.value.forEach((c: any) => {
      if (!selectedContacts.value.find((e: any) => e.id === c.id)) {
        filtered.push(c)
      }
    })
    return filtered
  },
  set: (data) => (contacts.value = data),
})
// const _expenses = (service: any) =>
//   expenses.value.filter((f: any) => !service.selectedExpenses.find((e: any) => e.id === f.id))
const _expenses = (service: any) => {
  return expenses.value
}
const _vehicles = (service: any) => {
  return vehicles.value
}

// const _vehicles = (service: any) =>
//   vehicles.value.filter((f: any) => !service.selectedVehicles.find((e: any) => e.id === f.id))
const originalSubTotalQuotation: any = computed(() => {
  let total = 0
  selectedServices.value.forEach((c: any) => {
    total = total + (c.total ?? 0) + (c.total_expenses ?? 0)
  })
  return _.ceil(total, 2)
})
const subTotalQuotation: any = computed(() => {
  let total = 0
  selectedServices.value.forEach((c: any) => {
    total = total + (c.total ?? 0) + (c.total_expenses ?? 0)
  })

  if (discountValue.value) {
    total = total - discountValue.value
  }
  return _.ceil(total, 2)
})
const discountValue: any = ref(0)
const igvQuotation: any = computed(() => {
  return _.ceil((subTotalQuotation.value * 18) / 100, 2)
})
const totalQuotation: any = computed(() => {
  return _.ceil(+subTotalQuotation.value + +igvQuotation.value, 2)
})
const openNewRoute = () => {
  showNewRoute.value = true
}
const showNewRoute: any = ref(null)
const contract: any = ref(null)

onMounted(async () => {
  loadingData.value = true
  await getAllContacts$()

  if (props.data) {
    await getInitialData()
    quotation.value = props.data

    discountValue.value = props.data?.discount ?? 0

    if (props.data.status === 4) {
      steps.value = [{ label: 'Resumen de cotización', icon: 'verified' }]
      step.value = 0
    }

    oportunityStore.getQuotationStates()

    const contactExists = _contacts.value.find((e: any) => e.id === props.data?.customer.id)
    if (contactExists) {
      selectedContacts.value = _contacts.value
        .filter((e: any) => e.id === props.data?.customer.id)
        .map((e: any) => ({ ...e, withCustomer: !!props.data?.customer.company }))
    } else {
      selectedContacts.value = [props.data?.customer]
    }

    props.data?.services.forEach((e: any) => {
      const service = services.value.find((s: any) => s.id === e.service.service)
      // const withroute = !!e.service?.route || !!e.service?.address_start
      const withroute = true
      selectedServices.value = [
        ...selectedServices.value,
        {
          ...service,
          _id: e.service._id,
          specifications: e.service.specifications,
          original: e.service,
          activetab: 'Servicio',
          activeDetailtab: 'Servicio',
          serviceDetail: {
            passengers: e.service.passengers,
            kilometers: e.service.kilometers,
            withdate: !!e.service.start_date,
            ...(e.service.date && {
              date: new Date(e.service.date),
              startdate: new Date(e.service.start_date),
              starttime: e.service.start_time && new Date(e.service.start_time),
              enddate: new Date(e.service.end_date),
              endtime: e.service.end_time && new Date(e.service.end_time),
              dateRange: {
                start: new Date(e.service.start_date),
                end: new Date(e.service.end_date),
              },
            }),
          },
          selectedExpenses: e.service.expenses.map((data: any) => {
            const expense = expenses.value.find((f: any) => f.id === data.expense)
            return { ...(expense ?? data.detail), total: data.amount, value: data.amount, quantity: data.quantity }
          }),
          selectedVehicles: e.service.vehicles.map((data: any) => {
            const vehicle = vehicles.value.find((f: any) => f.id === data.vehicle)
            return {
              ...(vehicle ?? data.vehicle_detail),
              _id: data.id,
              fee: data.vehiclefee,
              driver: {
                ...data.driver_detail,
                fee: data.driverfee,
                fee_1: data.driverfee_1,
                fee_2: data.driverfee_2,
                fee_time: data.hours,
                feetotal: data.driverfee_total,
              },
              quantity: data.quantity,
              withDriver: true,
              fee_total_perdays: data.total_days,
            }
          }),
          openned: false,
          calculated: null,
          withroute,
          total: _.ceil(e.service.total, 2),
          totalExpenses: _.ceil(e.service.total_expenses, 2),
          tollsamount: _.ceil(e.service.total_tolls, 2),
          tollsPrice: _.ceil(e.service.total_tolls, 2),
          totalVehicles: _.ceil(e.service.total_vehicles, 2),
          _route: e.service.route?.id,
          _routetype: e.service.route_type,
        },
      ]
    })

    await quotationHaveContract(quotation.value.id).then((e: any) => {
      contract.value = e.data
    })
  } else {
    loadingData.value = false
    await getInitialData(true)
  }
})
const isRejected = computed(() => {
  return quotation.value?.status === 5
})
const canSave = computed(() => {
  return quotation.value?.status != 5 && quotation.value?.status != 4
})
const getInitialData = async (noLoading?: boolean) => {
  if (!noLoading) loadingData.value = true
  getAllRoutes$()

  await Promise.all([getAllServices(), getAllVehicles(), getAllDrivers(), getAllExpenses()]).then(
    ([servicesData, vehiclesData, driversData, expensesData]: any) => {
      vehicles.value = vehiclesData?.map((i: any) => ({
        ...i,
      }))

      drivers.value = driversData?.map((i: any) => ({
        ...i,
      }))
      services.value = servicesData?.map((i: any) => ({
        ...i,
      }))
      expenses.value = expensesData?.map((i: any) => ({
        ...i,
      }))

      loadingData.value = false
    },
  )
}
const getAllRoutes$ = async () => {
  const _routes = await getAllRoutes()
  routes.value = _routes
}
const getAllContacts$ = async () => {
  const contactsData: any = await getAllContacts()
  contacts.value = contactsData?.map((i: any) => ({
    ...i,
    names: i.fullname,
  }))
  _contacts.value = contacts.value
}
// const _routeSelected = (id: any) => {
//   return routes.value.find((e: any) => e.id === id)
// }
const closeViewCustomer = async () => {
  showViewCustomer.value = false
  showNewCustomer.value = false
  await getAllContacts$()
  const items: any[] = []
  selectedContacts.value.forEach((c: any) => {
    const i = contacts.value.find((f: any) => f.id === c.id)
    items.push(i)
  })
  selectedContacts.value = items
}
const addSelected = () => {
  if (selectedCustomer.value) {
    const selected: any = contacts.value.find((f: any) => f.id === selectedCustomer.value)
    selected.withCustomer = !!selected.company
    selectedContacts.value.push(selected)
    selectedCustomer.value = null
  }
}
const addVehicle = (service: any) => {
  if (service.selectedVehicle) {
    const vehicle = vehicles.value.find((f: any) => f.id === service.selectedVehicle)
    service.selectedVehicles.push({ ...vehicle, driver: { fee: 0, fee_time: 1 }, quantity: 1, withDriver: true })
    service.selectedVehicle = null
    updateTotal(service)
  }
}
const addExpense = (service: any) => {
  if (service.selectedExpense) {
    const expense = expenses.value.find((f: any) => f.id === service.selectedExpense)
    service.selectedExpenses.push({ ...expense, basevalue: expense.value, total: 0, quantity: 1 })
    service.selectedExpense = null
    updateTotal(service)
  }
}
const removeVehicle = (index: number, service: any) => {
  service.selectedVehicles.splice(index, 1)
}
const removeExpense = (index: number, service: any) => {
  service.selectedExpenses.splice(index, 1)
  updateTotal(service)
}
const editContact = (contact: any) => {
  contactSelected.value = contact
  showViewCustomer.value = true
}
const removeContact = (index: number) => {
  selectedContacts.value.splice(index, 1)
}
const updateTotal = (service: any) => {
  let startDate, endDate
  if (service._routetype === 1) {
    startDate = moment(service.serviceDetail.startdate)
    endDate = moment(service.serviceDetail.enddate)
  } else {
    startDate = moment(service.serviceDetail.date)
    endDate = moment(service.serviceDetail.date)
  }

  const days = endDate.diff(startDate, 'days') + 1 || 1
  //
  service.fee = _.ceil(service?.fee, 2)

  const fee = +service?.fee || 0
  // const tollsFrom = (service._route ? selectedRoute(service._route) : +service?.serviceDetail?.tollsFrom) || 0
  // const tollsTo = (service._route ? selectedRoute(service._route) : +service?.serviceDetail?.tollsTo) || 0
  let tollsAmount = 0

  // const tollsAmount =
  //   (service._route && service._routetype === 1
  //     ? tollsFrom + tollsTo
  //     : service._routetype === 1
  //       ? tollsFrom + tollsTo
  //       : tollsFrom) || 0

  // Tolls Price
  let vehiclesPrices = 0
  let expensesPrices = 0
  // Vehicles Price
  const selectedVehicles = service?.selectedVehicles || []

  selectedVehicles.forEach((vehicle: any) => {
    if (service._route) {
      //
      const currentRoute = selectedRoute(service._route)
      const currentTollsTo =
        currentRoute?.tolls.find((f: any) => f.vehicle_type === vehicle.type && f.type === 1)?.amount || 0
      const currentTollsFrom =
        currentRoute?.tolls.find((f: any) => f.vehicle_type === vehicle.type && f.type === 0)?.amount || 0

      tollsAmount += (service._routetype === 1 ? currentTollsFrom + currentTollsTo : currentTollsTo) || 0
    } else {
      //
    }
  })

  let tollsPrice = tollsAmount + fee

  selectedVehicles.forEach((vehicle: any) => {
    const vehicleFee = +vehicle.fee || 0
    const vehicleFeePerDays = vehicleFee * days
    const quantity = +vehicle.quantity || 0
    const driverFee = +vehicle.driver?.fee || 0
    const driverFeeTime = +vehicle.driver?.fee_time || 0
    const driverFeeTotal = driverFee * driverFeeTime

    vehicle.fee_total_perdays = vehicleFeePerDays

    if (vehicle.driver) {
      vehicle.driver.feetotal = driverFeeTotal
    }

    const total = (vehicleFeePerDays + driverFeeTotal) * quantity
    vehiclesPrices += total
    tollsPrice += total
  })
  const selectedExpenses = service?.selectedExpenses || []
  selectedExpenses.forEach((expense: any) => {
    const value = +expense.value || 0
    const quantity = +expense.quantity || 0
    const total = value * quantity
    expensesPrices += total
  })

  tollsPrice += expensesPrices

  service.tollsamount = _.ceil(tollsAmount, 2)
  service.total = _.ceil(tollsPrice, 2)
  service.totalVehicles = _.ceil(vehiclesPrices, 2)
  service.totalExpenses = _.ceil(expensesPrices, 2)
}
const formatFn = (date: any) => {
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
}
const addSelectedService = (e?: any) => {
  const selected = e ? e.id : selectedService.value
  if (selected) {
    const selectedVehicles: any[] = []
    if (e?.selectedVehicles?.length) {
      e.selectedVehicles.forEach((f: any) => {
        selectedVehicles.push({ ...f })
      })
    }

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const wDates = {
      withdate: false,
      startdate: today,
      enddate: today,
      date: today,
      dateRange: {
        start: today,
        end: today,
      },
    }

    const newService = {
      ...services.value.find((f: any) => f.id === selected),
      activetab: 'Servicio',
      activeDetailtab: 'Servicio',
      serviceDetail: e ? { ...e.serviceDetail, ...wDates } : { ...wDates },
      selectedExpenses: [],
      selectedVehicles,
      withroute: true,
      withdate: false,
      openned: true,
      calculated: null,
      tollsPrice: null,
      total: 0,
      routeType: 0,
    }
    newService.totalExpenses = 0
    newService.tollsamount = 0
    newService.total = newService.fee
    newService.totalVehicles = 0
    newService.tollsPrice = () => {
      const tollsTo = +newService?.serviceDetail?.tollsTo || 0
      const tollsFrom = +newService?.serviceDetail?.tollsFrom || 0
      return tollsTo + tollsFrom
    }

    selectedServices.value.push(newService)
    selectedService.value = null
  }
}
const driverFee = (driver: number) => drivers.value.find((f: any) => f.id === driver)
const onChangeDriver = (i: any, service: any) => {
  if (i.withDriver) {
    const driver = driverFee(i.driver)
    i.driver = { ...driver }
  } else i.driver = null
  updateTotal(service)
}
// const updateDriver = (i: any, service: any) => {
//   i.driver = null
//   updateTotal(service)
// }
const needConfirm = (index: any) => {
  showConfirm.value = index !== null ? true : false
  confirSelected.value = index
}
const doDelete = () => {
  selectedServices.value.splice(confirSelected.value, 1)
  needConfirm(null)
}
const totalFeePerVehicle = (i: any) => {
  // const fee = +i.fee || 0
  const driverFee = +i.driver?.fee || 0
  const driverFeeTime = +i.driver?.fee_time || 0
  const driverFeeTotal = driverFee * driverFeeTime

  if (i.driver) {
    i.driver.feetotal = _.ceil(driverFeeTotal, 2)
  }

  // return fee + driverFee * i.quantity
  return _.ceil(driverFeeTotal + i.fee_total_perdays, 2)
}
const totalFeePerExpense = (i: any) => {
  const fee = i.value || 0
  return fee * i.quantity
}
// const copyOnNew = (index: number) => {
//   const service = selectedServices.value[index]
//   addSelectedService(service)
// }
const defineRoute = (service: any) => {
  service._routetype = 1
  service.serviceDetail.tollsFrom = 0
  service.serviceDetail.tollsTo = 0
  if (service.noroute) {
    service._route = null
  }
  updateTotal(service)
}
const selectedRoute = (id: any) => {
  return routes.value.find((f: any) => f.id === id)
}
const closeProcess = () => {
  confirmProcess.value = false
  errors.value = []
}
const parseFullDate = (date: any, dateTime: any) => {
  if (date && dateTime) {
    const timeHours = dateTime.getHours()
    const timeMinutes = dateTime.getMinutes()
    date.setHours(timeHours)
    date.setMinutes(timeMinutes)
    return date
  }

  return date
}
const updateWithDiscount = () => {
  console.log(discountValue.value, originalSubTotalQuotation.value)
  if (discountValue.value > originalSubTotalQuotation.value) {
    notify({
      message: 'El descuento no puede ser mayor',
      color: 'danger',
      duration: 2000,
    })
    discountValue.value = 0
  }
}
const doCreate = async () => {
  //
}
const validateBeforeSave = () => {
  const services: any = selectedServices.value
  const clients: any = selectedContacts.value[0]
  const defaultWarning = { title: 'Hay observaciones', color: 'danger', duration: 2000 }
  let withoutError = true
  if (!clients) {
    notify({
      message: 'Debe seleccionar un contacto',
      ...defaultWarning,
    })
    withoutError = false
  }
  if (!services.length) {
    notify({
      message: 'Debes agregar un servicio',
      ...defaultWarning,
    })
    withoutError = false
  }

  services.forEach((s: any) => {
    if (!s.withroute) {
      notify({
        message: 'Debe seleccionar una ruta',
        ...defaultWarning,
      })
      withoutError = false
    }

    if (s.withroute && (!s._route || s._routetype === null)) {
      notify({
        message: 'Falta definir el tipo de ruta',
        ...defaultWarning,
      })
      withoutError = false
    }

    if (s.withroute && s.selectedVehicles.length === 0) {
      notify({
        message: 'Falta agregar almenos un vehiculo',
        ...defaultWarning,
      })
      withoutError = false
    }

    s.selectedVehicles.forEach((e: any) => {
      if (!e.driver?.id) {
        notify({
          message: 'Los vehiculos deben tener un tipo de conductor definido',
          ...defaultWarning,
        })
        withoutError = false
      }
    })
  })

  return withoutError
}

const loadingQ = ref(false)

const onChangeStatus = async (data: any) => {
  oportunityStore.setActiveOportunity(data)
  oportunityStore.viewConfirm()
}
const doGenerateQuotation = async () => {
  if (validateBeforeSave()) {
    oportunityStore.setActiveOportunity(quotation.value)
    await oportunityStore.doGenerateQuotation()
    const win = window.open(`${HOST}/oportunities/pdf/${quotation.value.id}`)
    const timer = setInterval(function () {
      if (win?.closed) {
        clearInterval(timer)
        setTimeout(() => emit('close'), 1000)
      }
    }, 1000)
  }
}
const downloadPdf = () => {
  const services: any = selectedServices.value
  const clients: any = selectedContacts.value[0]

  if (!clients) {
    notify({
      message: 'Debe seleccionar un contacto',
      color: 'danger',
      duration: 1000,
    })

    return false
  }

  if (!services.length) {
    notify({
      message: 'Debes agregar un servicio',
      color: 'danger',
      duration: 1000,
    })

    return false
  }

  window.open(`${HOST}/oportunities/pdf/${quotation.value.id}`)
}
const doNext = (nextStep: any) => {
  nextStep()
}
const closeNewComment = () => {
  showNewComment.value = false
}
const isLoading = ref(false)
const router = useRouter()
const orderStore = useOrdersStore()
const openOrder = async (id: any) => {
  isLoading.value = true

  const order: any = await newOrder({
    id,
  })
  const newOrders = order.news
  const exists = order.exists

  if (exists.length > 0) {
    notify({
      message: 'La cotización tiene ordenes existentes',
      color: 'info',
      duration: 2500,
    })
    orderStore.showOrders(exists)
    isLoading.value = false
  } else {
    if (newOrders.length > 1) {
      notify({
        message: 'Proceso realizado correctamente',
        color: 'success',
        duration: 2500,
      })
      orderStore.showOrders(newOrders)
      isLoading.value = false
    } else {
      notify({
        message: 'Se ha creado la orden #' + newOrders[0],
        color: 'success',
        duration: 2500,
      })
      isLoading.value = false
      router.push('/orders/view/' + newOrders[0])
    }
  }
}

const doSave = async () => {
  errors.value = []

  const body: any = {
    services: [],
    title: quotation.value.title,
    total: totalQuotation.value,
    discount: discountValue.value,
    subtotal: subTotalQuotation.value,
    taxes: igvQuotation.value,
  }
  const services: any = selectedServices.value
  const clients: any = selectedContacts.value[0]

  if (!clients) {
    errors.value.push('Debe seleccionar un contacto')
    notify({
      message: 'Debe seleccionar un contacto',
      color: 'danger',
      duration: 1000,
    })
  } else {
    body.customer = {
      id: clients.id,
      ...(clients.withCustomer && { company: clients.company?.id }),
    }
  }
  if (!services.length) {
    errors.value.push('Debes agregar un servicio')

    notify({
      message: 'Debes agregar un servicio',
      color: 'danger',
      duration: 1000,
    })
  } else {
    services.forEach((s: any) => {
      const end = parseFullDate(s.serviceDetail.date, s.serviceDetail.endtime)
      const start = parseFullDate(s.serviceDetail.date, s.serviceDetail.starttime)
      body.services.push({
        _id: s._id,
        service: s.id,
        specifications: s.specifications,
        withroute: s.noroute,
        route: s._route,
        route_type: s._routetype,
        days: s.days,
        kilometers: +s.kilometers,
        passengers: +s.serviceDetail?.passengers,
        tollsFrom: s.serviceDetail?.tollsFrom,
        tollsTo: s.serviceDetail?.tollsTo,
        traveldays: s.serviceDetail?.traveldays,
        // ...(start && { start_date: start }),
        // ...(end && { end_date: end }),
        ...(s.serviceDetail.withdate
          ? {
              ...(s.serviceDetail.date && {
                date: s.serviceDetail.date,
                start_date: start,
                end_date: end,
                endtime: s.serviceDetail.endtime,
                starttime: s.serviceDetail.starttime,
              }),
            }
          : {
              date: null,
              start_date: null,
              end_date: null,
              endtime: null,
              starttime: null,
            }),
        total: s.total,
        total_tolls: s.tollsamount,
        total_expenses: s.totalExpenses,
        total_vehicles: s.totalVehicles,
        vehicles: s.selectedVehicles?.map((e: any) => ({
          _id: e._id,
          id: e.id,
          driver_type: e.driver?.type,
          driver: e.driver?.id,
          hours: e.driver?.fee_time,
          total_days: e.fee_total_perdays,
          driverfee_total: e.driver?.feetotal,
          driver_fee: e.driver?.fee,
          driver_fee_1: e.driver?.fee_1,
          driver_fee_2: e.driver?.fee_2,
          cost: e.cost,
          capacity: e.capacity,
          fee: e.fee,
          quantity: e.quantity,
        })),
        expenses: s.selectedExpenses?.map((e: any) => ({
          id: e.id,
          fee: e.value,
          name: e.name,
          quantity: e.quantity,
        })),
      })
    })
  }

  if (!errors.value.length) {
    if (!quotation.value.id) {
      loadingQ.value = true
      await newOportunity(body)

      notify({
        message: 'Cotización guardada correctamente',
        color: 'success',
        duration: 1000,
      })

      confirmProcess.value = false
      loadingQ.value = false

      if (!quotation.value.id) {
        emit('close')
      }
    } else {
      //
      loadingQ.value = true
      await updateQuotation(quotation.value.id, body)

      notify({
        message: 'Cotización actualizada correctamente',
        color: 'success',
        duration: 1000,
      })

      loadingQ.value = false

      if (!quotation.value.id) {
        emit('close')
      }
    }
  }
}
const clearRoute = (service: any) => {
  service._route = null
  updateTotal(service)
}
const openNewContract = async () => {
  isLoading.value = true
  await quotationHaveContract(quotation.value.id).then((e: any) => {
    if (!e.data) {
      showNewContract.value = true
    } else {
      contractId.value = e.data?.id
      showViewContract.value = true
    }
    isLoading.value = false
  })
}

const { confirm } = useModal()

const sendQuotation = async () => {
  confirm({
    size: '300px',
    title: '¿Desea enviar la cotización?',
    cancelText: 'Cancelar',
    okText: 'Enviar',
  }).then((ok) => {
    if (ok) {
      loadingQ.value = true
      sendQuotationToMail(quotation.value.id).then((e: any) => {
        loadingQ.value = false
        quotation.value.status = 3
        notify({
          message: 'Proceso realizado correctamente',
          color: 'success',
          duration: 2500,
        })
      })
    }
  })
}
// const switchRoute = (service: any) => {
//   service.routeType = service.routeType === 0 ? 1 : 0
// }
</script>

<template>
  <div class="bg-blue-50 pb-5">
    <div>
      <h3 v-if="_withSerie" class="pb-1 capitalize text-primary font-bold">{{ quotation.title }}</h3>
      <div v-if="!loadingData" class="flex justify-between align-center justify-center">
        <h1 v-if="!_noedit" class="h5 font-bold m-0">{{ props.data ? 'Editar Cotización' : 'Nueva Cotización' }}</h1>
        <h1 v-if="_noedit" class="h5 font-bold m-0">
          Detalle de Cotización
          <span class="font-bold text-xs bg-primary text-white px-1.5 py-0.5 rounded relative -top-0.5"
            >#{{ quotation.id }}</span
          >
        </h1>

        <div v-if="!loadingData" class="flex relative -top-1">
          <div class="flex w-full gap-2">
            <VaSelect
              v-if="quotation.status && quotation.status !== 1"
              v-model="quotation.status"
              :background="quotation.status === 4 ? '#c3ffcb' : quotation.status === 5 ? '#ffa1a1' : '#d5e3ff'"
              :options="statuses"
              :readonly="quotation.status === 4"
              value-by="id"
              text-by="label"
              placeholder="---"
              :loading="isOnChangeStatus"
              no-options-text="-- No hay items --"
              class="text-xs relative top-0.5"
              style="--va-input-wrapper-border-color: transparent; width: 150px"
              @update:modelValue="onChangeStatus(quotation)"
            />

            <VaButton
              v-if="quotation.status === 1"
              class="ml-3 top-0.5"
              icon="rocket_launch"
              color="primary"
              :disabled="!quotation.title"
              :loading="loadingQ"
              @click="sendQuotation()"
            >
              Enviar cotización
            </VaButton>

            <VaButton
              v-if="quotation.status === 4"
              icon="assignment_add"
              class="top-0.5"
              color="#02a65a"
              :loading="isLoading"
              :disabled="!!contract"
              @click="openNewContract()"
            >
              <span class="text-xs px-1">Contrato</span>
            </VaButton>

            <VaButton
              v-if="!_withSerie && canSave"
              class="ml-3 top-0.5"
              icon="save_as"
              color="info"
              :disabled="!quotation.title"
              :loading="loadingQ"
              @click="doSave()"
            >
              Grabar
            </VaButton>

            <VaButton
              v-if="quotation.status"
              icon="add_comment"
              class="top-0.5"
              color="info"
              @click="showNewComment = true"
            >
              <span class="text-xs px-1">Interacción</span>
            </VaButton>

            <VaButton
              icon="picture_as_pdf"
              class="top-0.5"
              color="#6c48d9"
              :disabled="!quotation.id"
              @click="downloadPdf"
            >
              <span class="text-xs px-1">PDF</span>
            </VaButton>
          </div>
        </div>
      </div>

      <div v-if="!loadingData && !_withSerie" class="mt-2 bg-white px-2 pt-3 pb-4">
        <VaInput
          v-model="quotation.title"
          background="#d5e3ff"
          name="firstName"
          label="Motivo de cotización"
          :rules="[validators.required]"
          autofocus
          :loading="loadingData"
          immediate-validation
        >
          <template #prepend>
            <span v-if="quotation?.serie" class="font-bold text-xs pr-1">#00{{ quotation.serie }}</span>
          </template>
        </VaInput>
      </div>
    </div>

    <div v-if="!loadingData" class="mt-5 bg-white px-3 py-4">
      <VaTabs v-if="_noedit && !contract" v-model="activeDetailTab" center class="mb-7">
        <template #tabs>
          <VaTab v-for="tab in ['Información de Cotización', 'Interacciones']" :key="tab">
            {{ tab }}
          </VaTab>
        </template>
      </VaTabs>

      <VaTabs v-if="_noedit && contract" v-model="activeDetailTab" center class="mb-7">
        <template #tabs>
          <VaTab v-for="tab in ['Información de Cotización', 'Interacciones', 'Contrato']" :key="tab">
            {{ tab }}
          </VaTab>
        </template>
      </VaTabs>

      <VaStepper
        v-if="activeDetailTab === 0 && quotation.status != 4"
        v-model="step"
        class="text-sm new-stepper"
        :steps="steps"
        controls-hidden
        linear
      >
        <template #step-content-0>
          <section class="bg-blue-50">
            <div v-if="!props.data" class="p-3">
              <div class="flex justify-between align-content-end">
                <VaSelect
                  v-model="selectedCustomer"
                  class="w-1/3 pt-1 text-xs"
                  background="#fff"
                  :options="_contacts"
                  value-by="id"
                  text-by="fullname"
                  placeholder="---"
                  no-options-text="-- No hay items --"
                  searchable
                  label="Selecciona o crea un contacto"
                  search-placeholder-text="Buscar contacto"
                  highlight-matched-text
                  :disabled="selectedContacts.length"
                  @update:modelValue="() => addSelected()"
                >
                  <!-- <template #append>
                    <VaIcon name="add_circle" class="ml-2 material-symbols-outlined" @click="addSelected" />
                  </template> -->
                </VaSelect>

                <!-- :rules="[validators.required]"
                immediate-validation -->

                <VaButton
                  class="ml-3 mr-2 pr-1 pl-1 material-symbols-outlined button-new"
                  icon="person_add"
                  color="primary"
                  :disabled="selectedContacts.length"
                  @click="showNewCustomer = true"
                >
                  <span class="pl-1">Nuevo Cliente</span>
                </VaButton>
              </div>
            </div>

            <div v-if="selectedContacts.length" class="p-3 px-4">
              <h3 class="border-b text-xs pb-2 text-black font-bold">Cliente Seleccionado:</h3>

              <VaList class="mt-2">
                <VaListItem
                  v-for="(contact, index) in selectedContacts"
                  :key="index"
                  class="list__item bg-white pl-3 py-1 mb-3"
                >
                  <VaListItemSection>
                    <VaListItemLabel v-if="!props.data" class="font-bold text-xs">
                      <span
                        class="hover:underline cursor-pointer uppercase text-primary"
                        @click="editContact(contact.id)"
                      >
                        {{ contact.fullname }}
                      </span>
                    </VaListItemLabel>

                    <VaListItemLabel v-if="props.data" class="font-bold text-xs">
                      <span class="cursor-pointer uppercase text-primary">
                        {{ contact.fullname }}
                      </span>
                    </VaListItemLabel>

                    <VaListItemLabel caption class="text-xs text-black">
                      <p v-if="!contact.company || (contact.company && !contact.withCustomer)">
                        <span>
                          <span class="font-bold">Documento:</span>
                          {{ contact.document ?? '-' }}
                        </span>

                        <span class="pl-3">
                          <span class="font-bold">Teléfono:</span>
                          {{ contact.cellphone ?? '-' }}
                        </span>
                      </p>

                      <p v-if="contact.company || (contact.company && contact.withCustomer)">
                        <span class="font-bold">Empresa:</span>
                        {{ contact.company?.socialreason ?? '-' }}
                      </p>
                    </VaListItemLabel>
                  </VaListItemSection>

                  <VaListItemSection icon>
                    <VaSwitch
                      v-if="contact.company"
                      v-model="contact.withCustomer"
                      class="check-type"
                      :disabled="!contact.company"
                      :readonly="props.data"
                      label="Como empresa"
                      size="small"
                    />

                    <VaIcon
                      v-if="!props.data"
                      name="edit"
                      class="material-symbols-outlined cursor-pointer ml-5"
                      @click="editContact(contact.id)"
                    />
                    <VaIcon
                      v-if="!props.data"
                      name="close"
                      class="material-symbols-outlined cursor-pointer"
                      @click="removeContact(index)"
                    />
                  </VaListItemSection>
                </VaListItem>
              </VaList>
            </div>
          </section>
        </template>
        <template #step-content-1>
          <section class="bg-blue-50 px-3 py-4">
            <div class="flex gap-3 mb-3">
              <VaSelect
                v-model="selectedService"
                class="w-2/5 mb-3 text-xs"
                background="#fff"
                label="Servicio"
                :options="services"
                no-options-text="-- No hay items --"
                value-by="id"
                text-by="service"
                placeholder="---"
                :disabled="!canSave"
              >
                <template #append>
                  <VaIcon name="add_circle" class="ml-2 material-symbols-outlined" @click="addSelectedService(null)" />
                </template>
              </VaSelect>
            </div>

            <h3 class="border-b text-xs pb-2 text-black font-bold">Servicios Seleccionados:</h3>

            <VaCollapse
              v-for="(service, index) in selectedServices"
              :key="index"
              v-model="service.openned"
              class="min-w-96 mb-1"
              style="--va-toast-content-font-size: 0.7rem; --va-background-border: transparent"
              :header="service.service"
              solid
              color="primary"
            >
              <div class="p-1 pt-3 bg-white mb-3">
                <VaTabs v-model="service.activetab" stateful grow>
                  <template #tabs>
                    <VaTab
                      v-for="title in ['Servicio', 'Vehiculos', 'Viáticos']"
                      :key="title"
                      :name="title"
                      class="bg-red text-primary"
                    >
                      {{ title }}

                      <VaBadge
                        v-if="service.selectedVehicles.length && title === 'Vehiculos'"
                        placement="top"
                        :text="service.selectedVehicles.length"
                        overlap
                        color="primary"
                        rounded
                        :offset="[-50, -10]"
                        class="ml-1"
                        style="--va-badge-text-wrapper-border-radius: 50%"
                      />

                      <VaBadge
                        v-if="service.selectedExpenses.length && title === 'Viáticos'"
                        placement="top"
                        :text="service.selectedExpenses.length"
                        overlap
                        color="primary"
                        rounded
                        :offset="[-50, -10]"
                        class="ml-1"
                        style="--va-badge-text-wrapper-border-radius: 50%"
                      />
                    </VaTab>
                  </template>
                </VaTabs>

                <div v-if="service.activetab === 'Servicio'" class="pt-4">
                  <div class="columns-2 bg-white px-2">
                    <div class="flex gap-3">
                      <VaSelect
                        v-model="service.service"
                        class="w-full mb-3 text-xs"
                        background="#d5e3ff"
                        readonly
                        label="Tipo de servicio"
                        :options="services"
                        no-options-text="-- No hay items --"
                        value-by="id"
                        text-by="service"
                        placeholder="---"
                      />
                    </div>
                    <VaInput v-model="service.description" background="#d5e3ff" readonly name="firstName" label="-" />
                  </div>

                  <!-- <div class="columns-2 px-2 py-1 mt-2 mb-1">
                    <VaCheckbox v-model="service.withroute" :disabled="_noedit" class="text-xs" label="Incluir ruta" />
                  </div> -->

                  <div v-if="service.withroute">
                    <div class="columns-2 px-2 pt-2">
                      <div class="w-full flex">
                        <VaSelect
                          v-model="service._route"
                          class="w-full text-xs"
                          background="#d5e3ff"
                          label="Selecciona una ruta"
                          :options="routes"
                          value-by="id"
                          searchable
                          clearable
                          no-options-text="-- No hay items --"
                          search-placeholder-text="Buscar ruta"
                          text-by="name"
                          placeholder="---"
                          immediate-validation
                          :disabled="service.noroute || !canSave"
                          :rules="[validators.required]"
                          @clear="() => clearRoute(service)"
                          @update:modelValue="() => updateTotal(service)"
                        >
                          <template #option="{ option, selectOption }">
                            <div
                              class="font-bold text-xs px-1 py-0.5 hover:bg-primary cursor-pointer hover:text-white"
                              @click="selectOption(option)"
                            >
                              {{ option?.name }}
                            </div>
                          </template>

                          <template #content="{ value }">
                            <span>
                              De <b class="uppercase"> {{ service.routeType !== 0 ? value.from : value.to }} </b> a
                              <b class="uppercase"> {{ service.routeType !== 0 ? value.to : value.from }} </b>
                            </span>
                          </template>
                        </VaSelect>

                        <div class="pt-5 ml-1">
                          <!--                          <VaButton-->
                          <!--                            :preset="service.routeType == 0 ? '' : 'secondary'"-->
                          <!--                            :color="service.routeType == 0 ? 'primary' : ''"-->
                          <!--                            title="Cambiar"-->
                          <!--                            icon="route"-->
                          <!--                            size="small"-->
                          <!--                            @click="switchRoute(service)"-->
                          <!--                            class="relative ml-1 mr-1"-->
                          <!--                          />-->

                          <!-- <VaButton
                            :preset="service.routeType == 1 ? '' : 'secondary'"
                            :color="service.routeType == 1 ? 'primary' : ''"
                            title="Solo Ruta"
                            border-color="primary"
                            icon="turn_slight_right"
                            size="small"
                            @click="switchRoute(service)"
                            class="relative"
                          /> -->
                        </div>
                      </div>

                      <!-- <div class="pt-3 relative top-1">
                        <VaCheckbox
                          v-model="service.noroute"
                          :disabled="service._route"
                          class="text-xs mt-2"
                          label="Ruta no definida"
                          @update:modelValue="defineRoute(service)"
                        />
                      </div> -->

                      <div>
                        <VaButton
                          class="material-symbols-outlined button-new"
                          style="position: relative; top: -3px"
                          icon="directions"
                          color="primary"
                          :disabled="!canSave"
                          @click="openNewRoute()"
                        >
                          <span class="pl-1">Nueva Ruta</span>
                        </VaButton>
                      </div>
                    </div>

                    <div v-if="service.noroute" class="pb-3">
                      <div class="columns-3 mb-4 px-2">
                        <div>
                          <VaSelect
                            v-model="service._routetype"
                            background="#d5e3ff"
                            label="Tipo de ruta"
                            class="w-full text-xs max-w-[150px]"
                            no-options-text="-- No hay items --"
                            :options="types"
                            value-by="id"
                            text-by="label"
                            placeholder="---"
                            immediate-validation
                            :rules="[validators.required]"
                            :disabled="!canSave"
                            @update:modelValue="() => updateTotal(service)"
                          />

                          <VaCheckbox
                            v-model="service.serviceDetail.withdate"
                            class="text-xs mt-2"
                            label="Incluir fecha de servicio"
                          />
                        </div>
                      </div>

                      <div class="flex bg-white px-2 pb-2 gap-3">
                        <div class="w-1/2">
                          <InputAddress
                            label="Dirección de origen"
                            @selected="(e) => (service.serviceDetail.addressfrom = e)"
                          />
                        </div>
                        <div class="w-1/2">
                          <InputAddress
                            label="Dirección de destino"
                            @selected="(e) => (service.serviceDetail.addressto = e)"
                          />
                        </div>
                      </div>
                      <div class="columns-3 bg-white px-2 pt-2">
                        <div class="flex gap-3">
                          <VaInput
                            v-model="service.serviceDetail.kilometers"
                            label="Kilometros"
                            min="0"
                            type="number"
                          />
                        </div>
                        <!-- <div class="flex gap-3">
                          <VaInput
                            v-model="service.serviceDetail.traveldays"
                            label="Nro dias (Viaje)"
                            :readonly="_noedit"
                            min="0"
                            type="number"
                          />
                        </div> -->
                        <div class="flex gap-3">
                          <VaInput
                            v-model="service.serviceDetail.tollsFrom"
                            label="Peaje (Ida)"
                            @change="updateTotal(service)"
                          >
                            <template #prependInner>
                              <span class="px-0 font-bold text-sm">S/</span>
                            </template>
                          </VaInput>
                        </div>
                        <div v-if="service._routetype === 1" class="flex gap-3">
                          <VaInput
                            v-model="service.serviceDetail.tollsTo"
                            label="Peaje (Vuelta)"
                            @change="updateTotal(service)"
                          >
                            <template #prependInner>
                              <span class="px-0 font-bold text-sm">S/</span>
                            </template>
                          </VaInput>
                        </div>
                        <!-- <div class="flex gap-3">
                          <VaInput
                            v-model="service.serviceDetail.passengers"
                            label="Pasajeros"
                            :readonly="_noedit"
                            min="0"
                            type="number"
                          />
                        </div> -->
                      </div>
                    </div>

                    <div v-if="!service.noroute" class="columns-3 pb-4 bg-white px-2">
                      <div>
                        <VaSelect
                          v-model="service._routetype"
                          class="w-full text-xs"
                          background="#d5e3ff"
                          label="Tipo de ruta"
                          :options="types"
                          no-options-text="-- No hay items --"
                          value-by="id"
                          text-by="label"
                          placeholder="---"
                          immediate-validation
                          :disabled="!canSave"
                          :rules="[validators.required]"
                          @update:modelValue="() => updateTotal(service)"
                        />

                        <VaCheckbox
                          v-model="service.serviceDetail.withdate"
                          class="text-xs mt-2"
                          label="Incluir fecha de servicio"
                          :disabled="!canSave"
                          @update:modelValue="
                            (val: any) => {
                              service.serviceDetail.date = val ? new Date() : null
                            }
                          "
                        />
                      </div>
                      <!-- <div class="">
                        <VaInput
                          :model-value="_routeSelected(service._route)?.kilometers"
                          label="Kilometros"
                          min="0"
                          readonly
                          class="cursor-not-allowed"
                          background="primary"
                          type="number"
                        />
                      </div> -->
                      <!-- <div class="">
                        <VaInput
                          :model-value="
                            service._routetype === 2
                              ? _routeSelected(service._route)?.amount_from
                              : _routeSelected(service._route)?.amount
                          "
                          label="Costo de peaje"
                          readonly
                          class="cursor-not-allowed"
                          background="primary"
                          @change="updateTotal(service)"
                        >
                          <template #prependInner>
                            <span class="px-0 font-bold text-sm">S/</span>
                          </template>
                        </VaInput>
                      </div> -->
                      <!-- <div class="">
                        <VaInput
                          v-model="service.serviceDetail.passengers"
                          label="Pasajeros"
                          :readonly="_noedit"
                          min="0"
                          type="number"
                        />
                      </div> -->
                    </div>
                  </div>

                  <!-- <hr> -->

                  <!-- <div class="columns-2 px-2 py-1 mt-1">
                    <VaCheckbox
                      v-model="service.serviceDetail.withdate"
                      class="text-xs"
                      :disabled="_noedit"
                      label="Incluir fecha de servicio"
                    />
                  </div> -->
                  <div v-if="service.serviceDetail.withdate" class="columns-3 px-2 pt-1 mb-6">
                    <div class="gap-3 bg-white">
                      <div>
                        <VaDateInput
                          v-model="service.serviceDetail.date"
                          mode="single"
                          background="#fff"
                          label="Fecha del servicio"
                          :format-date="formatFn"
                          :rules="[validators.required]"
                          class="w-full"
                          @update:modelValue="
                            () => {
                              updateTotal(service)
                            }
                          "
                        />

                        <VaCheckbox
                          v-model="service.withTime"
                          class="text-xs mt-2"
                          label="Agregar hora de servicio"
                          @update:modelValue="defineRoute(service)"
                        />

                        <!-- <VaDateInput
                        v-if="service._routetype === 1"
                        v-model="service.serviceDetail.dateRange"
                        mode="range"
                        background="#fff"
                        label="Fecha de Servicio"
                        :format-date="formatFn"
                        :rules="[validators.required]"
                        :readonly="_noedit"
                        class="w-2/5"
                        @update:modelValue="
                          () => {
                            service.serviceDetail.startdate = service.serviceDetail.dateRange.start
                            service.serviceDetail.enddate = service.serviceDetail.dateRange.end

                            updateTotal(service)
                          }
                        "
                      /> -->
                      </div>
                    </div>
                    <div class="gap-3 bg-white pl-2">
                      <VaTimeInput
                        v-model="service.serviceDetail.starttime"
                        background="#fff"
                        :disabled="!service.withTime"
                        label="Hora de Inicio"
                        class="w-full relative -left-2"
                        ampm
                        @update:modelValue="updateTotal(service)"
                      />
                    </div>

                    <div class="gap-3 bg-white pl-2">
                      <VaTimeInput
                        v-model="service.serviceDetail.endtime"
                        background="#fff"
                        :disabled="!service.withTime"
                        label="Hora de Fin"
                        class="w-full relative -left-2"
                        ampm
                        @update:modelValue="updateTotal(service)"
                      />
                    </div>
                  </div>

                  <div class="columns-1 px-2">
                    <div class="mb-5">
                      <p style="font-size: 10.5px; font-weight: 600; color: var(--va-primary)">
                        Condiciones Especificas:
                      </p>
                      <QuillEditor
                        v-model:content="service.specifications"
                        theme="snow"
                        content-type="html"
                        :toolbar="['bold', 'italic']"
                      />
                    </div>
                  </div>
                </div>

                <div v-if="service.activetab === 'Vehiculos'" class="pt-4 px-2">
                  <div class="flex flex-col w-full">
                    <!-- <h4 class="text-sm font-bold mb-3">Unidades:</h4> -->
                    <div class="flex">
                      <div class="w-2/5 pr-3">
                        <VaSelect
                          v-model="service.selectedVehicle"
                          class="w-full text-xs"
                          background="#fff"
                          no-options-text="-- No hay items --"
                          label="Selecciona una unidad"
                          :options="_vehicles(service)"
                          value-by="id"
                          text-by="name"
                          placeholder="---"
                          :disabled="!canSave"
                        >
                          <template #append>
                            <VaIcon
                              name="add_circle"
                              class="ml-1 material-symbols-outlined"
                              @click="addVehicle(service)"
                            />
                          </template>
                        </VaSelect>
                      </div>
                    </div>

                    <hr class="mt-5" />

                    <div class="flex w-full flex-wrap mt-4 mb-5">
                      <p v-if="!service.selectedVehicles.length" class="text-xs bg-red-100 w-full p-1 px-2">
                        No hay vehiculos seleccionados.
                      </p>
                      <div v-for="(i, index) in service.selectedVehicles" :key="index" class="w-1/3 p-1">
                        <VaCard class="vehicle-type w-full bg-blue-50 rounded-none cursor-pointer pb-0">
                          <VaCardTitle class="pb-0 flex justify-between" style="--va-card-padding: 1rem 0.5rem">
                            <span class="capitalize font-light"> ({{ i.capacity }} Pasajeros) </span>
                            <VaIcon
                              v-if="canSave"
                              size="14px"
                              name="close"
                              class="material-symbols-outlined cursor-pointer"
                              @click="removeVehicle(index, service)"
                            />
                          </VaCardTitle>
                          <VaCardContent class="px-2">
                            <span class="font-bold">{{ i.name }}</span>
                            <hr class="my-2" />
                            <div class="flex gap-2">
                              <!-- <VaCheckbox
                                v-model="i.withDriver"
                                background="#fff"
                                :disabled="_noedit"
                                class="text-xs mt-6 bg-white"
                                @update:modelValue="() => updateDriver(i, service)"
                              /> -->
                              <VaSelect
                                v-model="i.driver"
                                class="driver-select w-full text-xs"
                                background="#fff"
                                label="Conductor"
                                :disabled="!canSave"
                                no-options-text="-- No hay items --"
                                :options="drivers"
                                value-by="id"
                                text-by="type"
                                placeholder="Selecciona un conductor"
                                :rules="[validators.required]"
                                immediate-validation
                                @update:modelValue="onChangeDriver(i, service)"
                              />
                            </div>

                            <!-- <div class="columns-2 justify-between align-center">
                              <p class="m-0 text-xs pt-3">Año</p>
                              <VaInput
                                v-model="i.year"
                                class="mt-2 text-right cursor-not-allowed"
                                background="#fff"
                                readonly
                                @change="updateTotal(service)"
                              />
                            </div> -->

                            <!-- <div class="columns-2 justify-between align-center">
                              <p class="m-0 text-xs pt-3">Unidades</p>
                              <VaCounter
                                v-model="i.quantity"
                                class="mt-2 w-full text-xs"
                                :min="1"
                                :max="99"
                                :disabled="_noedit"
                                outline
                                background="#fff"
                                @update:modelValue="updateTotal(service)"
                              />
                            </div> -->

                            <hr v-if="i.withDriver && i.driver?.id && i.driver?.fee" class="mt-2" />

                            <div
                              v-if="i.withDriver && i.driver?.id && i.driver?.fee"
                              class="columns-2 justify-between align-center"
                            >
                              <p class="m-0 text-xs pt-3">Tarifa Conductor <br /></p>
                              <VaInput
                                v-model="i.driver.fee"
                                v-only-numbers
                                class="mt-2"
                                readonly
                                background="primary"
                                :disabled="!i.driver?.type"
                                @change="updateTotal(service)"
                              >
                                <template #prependInner>
                                  <span class="px-0 -mx-1 font-bold text-sm">S/</span>
                                </template>
                              </VaInput>
                            </div>

                            <!--                            <div-->
                            <!--                              v-if="i.withDriver && i.driver?.id && i.driver?.fee"-->
                            <!--                              class="columns-2 justify-between align-center"-->
                            <!--                            >-->
                            <!--                              <p class="m-0 text-xs pt-3">Tarifa Nocturna</p>-->
                            <!--                              <VaInput-->
                            <!--                                v-model="i.driver.fee_1"-->
                            <!--                                v-only-numbers-->
                            <!--                                class="mt-2"-->
                            <!--                                background="#fff"-->
                            <!--                                :disabled="!i.driver?.type"-->
                            <!--                                @change="updateTotal(service)"-->
                            <!--                              >-->
                            <!--                                <template #prependInner>-->
                            <!--                                  <span class="px-0 -mx-1 font-bold text-sm">S/</span>-->
                            <!--                                </template>-->
                            <!--                              </VaInput>-->
                            <!--                            </div>-->

                            <!--                            <div-->
                            <!--                              v-if="i.withDriver && i.driver?.id && i.driver?.fee"-->
                            <!--                              class="columns-2 justify-between align-center"-->
                            <!--                            >-->
                            <!--                              <p class="m-0 text-xs pt-3">Domingos / fds</p>-->
                            <!--                              <VaInput-->
                            <!--                                v-model="i.driver.fee_2"-->
                            <!--                                v-only-numbers-->
                            <!--                                class="mt-2"-->
                            <!--                                background="#fff"-->
                            <!--                                :disabled="!i.driver?.type"-->
                            <!--                                @change="updateTotal(service)"-->
                            <!--                              >-->
                            <!--                                <template #prependInner>-->
                            <!--                                  <span class="px-0 -mx-1 font-bold text-sm">S/</span>-->
                            <!--                                </template>-->
                            <!--                              </VaInput>-->
                            <!--                            </div>-->

                            <div
                              v-if="i.withDriver && i.driver?.id && i.driver?.fee"
                              class="columns-2 justify-between align-center"
                            >
                              <p class="m-0 text-xs pt-3">Horas de Conductor</p>
                              <VaInput
                                v-model="i.driver.fee_time"
                                v-only-numbers
                                class="mt-2 no-padding"
                                type="number"
                                min=".5"
                                background="#fff"
                                :disabled="!i.driver?.type"
                                @change="updateTotal(service)"
                              />
                            </div>

                            <div
                              v-if="i.withDriver && i.driver?.id && i.driver?.fee"
                              class="columns-2 justify-between align-center"
                            >
                              <p class="m-0 text-xs pt-3"></p>
                              <VaInput v-model="i.driver.feetotal" v-only-numbers min="0" background="primary" readonly>
                                <template #prependInner>
                                  <span class="px-0 -mx-1 font-bold text-sm">S/</span>
                                </template>
                              </VaInput>
                            </div>

                            <hr class="mt-2" />

                            <div class="columns-2 justify-between align-center">
                              <p class="m-0 text-xs pt-3">
                                Tarifa Vehiculo
                                <!-- <br /> -->
                                <!-- <span class="text-xxs font-bold">(x Día)</span> -->
                              </p>
                              <VaInput
                                v-model="i.fee"
                                v-only-numbers
                                class="mt-2"
                                readonly
                                background="primary"
                                @change="updateTotal(service)"
                              >
                                <template #prependInner>
                                  <span class="px-0 -mx-1 font-bold text-sm">S/</span>
                                </template>
                              </VaInput>
                            </div>

                            <div v-if="false" class="columns-2 justify-between align-center">
                              <p class="m-0 text-xs pt-3"></p>
                              <VaInput v-model="i.fee_total_perdays" background="primary" readonly>
                                <template #prependInner>
                                  <span class="px-0 -mx-1 font-bold text-sm">S/</span>
                                </template>
                              </VaInput>
                            </div>

                            <hr class="mt-2" />

                            <div class="columns-2 justify-between align-center">
                              <p class="m-0 text-xs font-bold pt-3">TOTAL</p>
                              <VaInput
                                class="mt-2 font-bold cursor-not-allowed"
                                background="#c2d2f3"
                                :model-value="totalFeePerVehicle(i)"
                                readonly
                              >
                                <template #prependInner>
                                  <span class="px-0 -mx-1 font-bold text-sm">S/</span>
                                </template>
                              </VaInput>
                            </div>
                          </VaCardContent>
                        </VaCard>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="service.activetab === 'Viáticos'" class="pt-4 px-2">
                  <div class="flex flex-col w-full">
                    <!-- <h4 class="text-sm font-bold mb-3">Unidades:</h4> -->
                    <div class="flex">
                      <div class="w-1/3 pr-3">
                        <VaSelect
                          v-model="service.selectedExpense"
                          class="w-full text-xs"
                          background="#fff"
                          label="Selecciona un tipo de viático"
                          :options="_expenses(service)"
                          no-options-text="-- No hay items --"
                          :disabled="!canSave"
                          value-by="id"
                          text-by="name"
                          placeholder="---"
                        >
                          <template #append>
                            <VaIcon
                              name="add_circle"
                              class="ml-1 material-symbols-outlined"
                              @click="addExpense(service)"
                            />
                          </template>
                        </VaSelect>
                      </div>
                    </div>

                    <hr class="mt-5" />

                    <div class="flex w-full flex-wrap mt-4 mb-5">
                      <p v-if="!service.selectedExpenses.length" class="text-xs bg-red-100 w-full p-1 px-2">
                        No hay viáticos seleccionados.
                      </p>
                      <div v-for="(i, index) in service.selectedExpenses" :key="index" class="w-1/3 p-1">
                        <VaCard class="vehicle-type w-full bg-blue-50 rounded-none cursor-pointer pb-0">
                          <VaCardTitle class="pb-0 flex justify-between" style="--va-card-padding: 1rem 0.5rem">
                            <span class="capitalize font-light"> Valor base (S/ {{ i.basevalue }}) </span>
                            <VaIcon
                              v-if="canSave"
                              size="14px"
                              name="close"
                              class="material-symbols-outlined cursor-pointer"
                              @click="removeExpense(index, service)"
                            />
                          </VaCardTitle>
                          <VaCardContent class="px-2">
                            <span class="font-bold">{{ i.name }}</span>
                            <hr class="my-2" />
                            <!-- <div class="columns-2 justify-between align-center">
                              <p class="m-0 text-xs pt-3">Cantidad</p>
                              <VaCounter
                                v-model="i.quantity"
                                class="mt-2 w-full text-xs"
                                :min="1"
                                :max="99"
                                :disabled="_noedit"
                                outline
                                background="#fff"
                                @update:modelValue="updateTotal(service)"
                              />
                            </div> -->

                            <div class="columns-2 justify-between align-center">
                              <p class="m-0 text-xs pt-3">Monto Asignado</p>
                              <VaInput
                                v-model="i.value"
                                v-only-numbers
                                class="mt-2"
                                background="#fff"
                                :disabled="!canSave"
                                @change="updateTotal(service)"
                              >
                                <template #prependInner>
                                  <span class="px-0 -mx-1 font-bold text-sm">S/</span>
                                </template>
                              </VaInput>
                            </div>

                            <!-- <div class="columns-2 justify-between align-center">
                              <p class="m-0 text-xs pt-3">Total</p>
                              <VaInput
                                class="mt-2 font-bold"
                                background="#c2d2f3"
                                :readonly="_noedit"
                                :model-value="totalFeePerExpense(i)"
                              >
                                <template #prependInner>
                                  <span class="px-0 -mx-1 font-bold text-sm">S/</span>
                                </template>
                              </VaInput>
                            </div> -->
                          </VaCardContent>
                        </VaCard>
                      </div>
                    </div>
                  </div>
                </div>

                <hr class="mt-5" />

                <div class="flex flex-col justify-between my-3">
                  <div class="w-full px-2 columns-5">
                    <!-- <div>
                      <VaInput
                        v-model="service.fee"
                        v-only-numbers
                        class="mt-2 font-bold"
                        background="#c2d2f3"
                        label="Precio de servicio"
                        :rules="[validators.required]"
                        @change="updateTotal(service)"
                      >
                        <template #prependInner>
                          <span class="px-0 font-bold text-sm">S/</span>
                        </template>
                      </VaInput>
                    </div> -->

                    <div>
                      <VaInput
                        class="mt-2 font-bold cursor-not-allowed"
                        background="#c2d2f3"
                        :model-value="service.totalVehicles"
                        label="Tarifa vehiculos"
                        readonly
                        :rules="[validators.required]"
                      >
                        <template #prependInner>
                          <span class="px-0 font-bold text-sm">S/</span>
                        </template>
                      </VaInput>
                    </div>

                    <div>
                      <VaInput
                        class="mt-2 font-bold cursor-not-allowed"
                        background="#c2d2f3"
                        :model-value="service.totalExpenses"
                        label="Viáticos"
                        readonly
                        :rules="[validators.required]"
                      >
                        <template #prependInner>
                          <span class="px-0 font-bold text-sm">S/</span>
                        </template>
                      </VaInput>
                    </div>

                    <div>
                      <VaInput
                        v-if="service.withroute"
                        class="mt-2 font-bold cursor-not-allowed"
                        background="#c2d2f3"
                        :model-value="service.tollsamount"
                        label="Costo peajes"
                        readonly
                        :rules="[validators.required]"
                      >
                        <template #prependInner>
                          <span class="px-0 font-bold text-sm">S/</span>
                        </template>
                      </VaInput>
                    </div>

                    <div>
                      <VaInput
                        v-model="service.total"
                        v-only-numbers
                        class="mt-2 font-bold"
                        background="primary"
                        :class="_noedit && 'cursor-not-allowed'"
                        label="Precio final"
                        :disabled="!canSave"
                        :rules="[validators.required]"
                      >
                        <template #prependInner>
                          <span class="px-0 font-bold text-sm">S/</span>
                        </template>

                        <template #append>
                          <VaIcon
                            name="cached"
                            class="cursor-pointer rounded-full bg-blue-50 relative -mr-1 -right-1"
                            color="primary"
                            @click="updateTotal(service)"
                          />
                        </template>
                      </VaInput>
                    </div>
                  </div>

                  <div class="flex flex-col pr-2.5 pt-3 justify-end">
                    <div class="flex gap-2 justify-end">
                      <VaButton
                        v-if="canSave"
                        class="pr-1 -mr-2 pl-1 text-xxs material-symbols-outlined"
                        icon="close"
                        color="danger"
                        @click="needConfirm(index)"
                      >
                        <span class="pl-1 text-xxs">Eliminar servicio</span>
                      </VaButton>
                      <!--                                            <VaButton-->
                      <!--                                              class="pr-1 pl-1 material-symbols-outlined"-->
                      <!--                                              icon="close"-->
                      <!--                                              color="info"-->
                      <!--                                              @click="copyOnNew(index)"-->
                      <!--                                            >-->
                      <!--                                              <span class="pl-1">Duplicar </span>-->
                      <!--                                            </VaButton>-->
                    </div>
                  </div>
                </div>
              </div>
            </VaCollapse>
          </section>
        </template>
        <template #step-content-2>
          <section class="bg-info-50 px-3 py-4 pb-1">
            <h2 class="text-center font-bold uppercase mb-5 mt-2">Resumen de Cotización</h2>

            <div class="mb-5">
              <VaCollapse
                v-if="selectedContacts.length && false"
                v-model="clientsOpen"
                class="min-w-96 mb-2"
                style="--va-background-border: transparent"
                header="Contactos"
                solid
                color="primary"
              >
                <div>
                  <div v-for="(contact, index) in selectedContacts" :key="index" class="bg-white mb-1 relative">
                    <VaBadge
                      placement="top-left"
                      :text="'#' + (index + 1)"
                      overlap
                      color="primary"
                      class="absolute"
                      :offset="[-10, -10]"
                    />
                    <div class="columns-3 pt-6 py-3">
                      <div>
                        <VaInput
                          :model-value="contact.fullname"
                          label="Nombre de cliente"
                          background="#fff"
                          readonly
                          class="cursor-not-allowed"
                          placeholder="ej: Jr Malaga 200"
                        />
                      </div>
                      <div>
                        <VaInput
                          :model-value="contact.cellphone"
                          label="Teléfono"
                          background="#fff"
                          readonly
                          class="cursor-not-allowed"
                          placeholder="ej: Jr Malaga 200"
                        />
                      </div>
                      <div>
                        <VaInput
                          :model-value="contact.document"
                          label="Documento"
                          background="#fff"
                          readonly
                          class="cursor-not-allowed"
                          placeholder="ej: Jr Malaga 200"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </VaCollapse>

              <div v-if="selectedContacts.length" class="mb-4 mt-2 bg-white px-2 pt-2">
                <p class="font-semibold text-sm">Datos del cliente</p>
                <div v-for="(contact, index) in selectedContacts" :key="index" class="bg-white mb-1 relative">
                  <div v-if="!contact.withCustomer" class="columns-3 py-3">
                    <div>
                      <VaInput
                        :model-value="contact.fullname"
                        label="Nombre de cliente"
                        background="#d5e3ff"
                        readonly
                        class="cursor-not-allowed"
                      />
                    </div>
                    <div>
                      <VaInput
                        :model-value="contact.cellphone"
                        label="Teléfono"
                        background="#d5e3ff"
                        readonly
                        class="cursor-not-allowed"
                      />
                    </div>
                    <div>
                      <VaInput
                        :model-value="contact.document"
                        label="Documento"
                        background="#d5e3ff"
                        readonly
                        class="cursor-not-allowed"
                      />
                    </div>
                  </div>

                  <div v-if="contact.withCustomer" class="columns-3 py-3">
                    <div>
                      <VaInput
                        :model-value="contact.company?.socialreason"
                        label="Razón Social"
                        background="#d5e3ff"
                        readonly
                        class="cursor-not-allowed"
                      />
                    </div>
                    <div>
                      <VaInput
                        :model-value="contact.company?.ruc"
                        label="RUC"
                        background="#d5e3ff"
                        readonly
                        class="cursor-not-allowed"
                      />
                    </div>
                    <div>
                      <VaInput
                        :model-value="contact.company?.phone"
                        label="Teléfono"
                        background="#d5e3ff"
                        readonly
                        class="cursor-not-allowed"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <VaCollapse
                v-if="selectedServices.length"
                v-model="servicesOpen"
                class="min-w-96"
                style="--va-background-border: transparent"
                header="Servicios"
                solid
                color="primary"
              >
                <div class="">
                  <div v-for="(service, index) in selectedServices" :key="index" class="bg-white pb-3 relative">
                    <VaBadge
                      placement="top-left"
                      :text="'#' + (index + 1)"
                      overlap
                      class="absolute"
                      color="primary"
                      :offset="[-10, -10]"
                    />

                    <VaTabs v-model="service.activeDetailtab" stateful grow class="mb-3">
                      <template #tabs>
                        <VaTab v-for="title in ['Servicio', 'Vehiculos', 'Viáticos']" :key="title" :name="title">
                          {{ title }}
                          <VaBadge
                            v-if="service.selectedVehicles.length && title === 'Vehiculos'"
                            placement="top"
                            :text="service.selectedVehicles.length"
                            overlap
                            color="primary"
                            rounded
                            :offset="[-50, -10]"
                            class="ml-2 cursor-not-allowed"
                            style="--va-badge-text-wrapper-border-radius: 50%"
                          />

                          <VaBadge
                            v-if="service.selectedExpenses.length && title === 'Viáticos'"
                            placement="top"
                            :text="service.selectedExpenses.length"
                            overlap
                            color="primary"
                            rounded
                            :offset="[-50, -10]"
                            class="ml-2 cursor-not-allowed"
                            style="--va-badge-text-wrapper-border-radius: 50%"
                          />
                        </VaTab>
                      </template>
                    </VaTabs>

                    <div v-if="service.activeDetailtab === 'Servicio'" class="px-2 bg-white rounded">
                      <div class="flex gap-4 pr-3 pt-3">
                        <div class="w-1/2">
                          <VaSelect
                            v-model="service.id"
                            class="w-full mb-3 text-xs cursor-not-allowed"
                            background="#d5e3ff"
                            readonly
                            no-options-text="-- No hay items --"
                            label="Tipo de servicio"
                            :options="services"
                            value-by="id"
                            text-by="service"
                            placeholder="---"
                          />
                        </div>

                        <template v-if="service.withroute && !service._route">
                          <div class="w-1/4">
                            <VaInput
                              :model-value="service.serviceDetail.addressfrom"
                              label="Origen"
                              class="cursor-not-allowed"
                              style="--va-input-wrapper-border-color: transparent"
                              background="#eee"
                              readonly
                            />
                          </div>
                          <div class="w-1/4">
                            <VaInput
                              :model-value="service.serviceDetail.addressto"
                              label="Destino"
                              background="#eee"
                              style="--va-input-wrapper-border-color: transparent"
                              class="cursor-not-allowed"
                              readonly
                            />
                          </div>
                        </template>
                      </div>
                      <div v-if="service.withroute && !service._route" class="columns-4 py-1 pb-2">
                        <!-- <div>
                          <VaInput
                            :model-value="service.serviceDetail.kilometers"
                            label="Kilometros"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            class="cursor-not-allowed"
                            readonly
                          />
                        </div> -->
                        <!-- <div>
                          <VaInput
                            :model-value="service.serviceDetail.traveldays"
                            label="Dias de viaje"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            readonly
                            class="cursor-not-allowed"
                          />
                        </div> -->
                        <div>
                          <VaInput
                            :model-value="service.serviceDetail.tollsFrom"
                            label="Peajes (Ida)"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            class="cursor-not-allowed"
                            readonly
                          />
                        </div>
                        <div>
                          <VaInput
                            :model-value="service.serviceDetail.tollsTo"
                            label="Peajes (Vuelta)"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            class="cursor-not-allowed"
                            readonly
                          />
                        </div>
                        <!-- <div>
                          <VaInput
                            :model-value="service.serviceDetail.passengers"
                            label="Pasajeros"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            class="cursor-not-allowed"
                            readonly
                          />
                        </div> -->
                      </div>

                      <div v-if="service.withroute && service._route" class="columns-2">
                        <div>
                          <VaSelect
                            v-model="service._route"
                            background="#d5e3ff"
                            readonly
                            no-options-text="-- No hay items --"
                            label="Ruta seleccionada"
                            :options="routes"
                            value-by="id"
                            searchable
                            search-placeholder-text="Buscar ruta"
                            text-by="name"
                            placeholder="---"
                            class="w-full text-xs cursor-not-allowed"
                            style="--va-input-wrapper-border-color: transparent"
                          >
                            <template #option="{ option, selectOption }">
                              <div
                                class="font-bold text-xs px-1 py-0.5 hover:bg-primary cursor-pointer hover:text-white"
                                @click="selectOption(option)"
                              >
                                {{ option?.name }}
                              </div>
                            </template>
                          </VaSelect>
                        </div>
                      </div>
                      <div v-if="service.withroute && service._route" class="columns-3 py-1 pb-2 pt-3">
                        <div>
                          <VaSelect
                            v-model="service._routetype"
                            background="#d5e3ff"
                            readonly
                            label="Tipo de ruta"
                            :options="types"
                            value-by="id"
                            no-options-text="-- No hay items --"
                            text-by="label"
                            placeholder="---"
                            class="w-full text-xs cursor-not-allowed"
                            style="--va-input-wrapper-border-color: transparent"
                          />
                        </div>

                        <!-- <div>
                          <VaInput
                            :model-value="_routeSelected(service._route)?.kilometers"
                            label="Kilometros"
                            min="0"
                            class="cursor-not-allowed"
                            style="--va-input-wrapper-border-color: transparent"
                            background="#eee"
                            readonly
                            type="number"
                          />
                        </div> -->
                        <!-- <div class="flex">
                          <VaInput
                            v-model="service.serviceDetail.passengers"
                            class="cursor-not-allowed"
                            style="--va-input-wrapper-border-color: transparent"
                            label="Pasajeros"
                            background="#eee"
                            readonly
                            min="0"
                            type="number"
                          />
                        </div> -->
                      </div>

                      <div v-if="service.serviceDetail.withdate" class="columns-4 pb-3">
                        <div>
                          <!-- <VaDateInput
                            v-model="service.serviceDetail.startdate"
                            background="#eee"
                            label="Fecha de inicio"
                            :format="formatFn"
                            style="--va-input-wrapper-border-color: transparent"
                            class="cursor-not-allowed"
                            readonly
                          /> -->

                          <VaDateInput
                            v-model="service.serviceDetail.date"
                            mode="single"
                            background="#fff"
                            label="Fecha del servicio"
                            :format-date="formatFn"
                            :rules="[validators.required]"
                            class="w-full"
                            @update:modelValue="
                              () => {
                                updateTotal(service)
                              }
                            "
                          />
                        </div>
                        <div v-if="service.serviceDetail.starttime">
                          <VaTimeInput
                            v-model="service.serviceDetail.starttime"
                            background="#eee"
                            label="Hora Inicio"
                            style="--va-input-wrapper-border-color: transparent"
                            class="cursor-not-allowed"
                            ampm
                            readonly
                          />
                        </div>
                        <!-- <div>
                          <VaDateInput
                            v-model="service.serviceDetail.enddate"
                            background="#eee"
                            label="Fecha de fin"
                            :format="formatFn"
                            class="cursor-not-allowed"
                            style="--va-input-wrapper-border-color: transparent"
                            readonly
                          />
                        </div> -->
                        <div v-if="service.serviceDetail.endtime">
                          <VaTimeInput
                            v-model="service.serviceDetail.endtime"
                            background="#eee"
                            label="Hora Fin"
                            style="--va-input-wrapper-border-color: transparent"
                            class="cursor-not-allowed"
                            ampm
                            readonly
                          />
                        </div>
                      </div>

                      <div class="columns-1">
                        <div class="mb-5">
                          <p style="font-size: 10.5px; font-weight: 600; color: var(--va-primary)">
                            Condiciones Especificas:
                          </p>
                          <QuillEditor
                            v-model:content="service.specifications"
                            theme="snow"
                            content-type="html"
                            :toolbar="['bold', 'italic']"
                          />
                        </div>
                      </div>

                      <div class="columns-5 pb-4">
                        <!-- <div>
                          <VaInput
                            class="mt-2 font-bold cursor-not-allowed"
                            background="#c2d2f3"
                            :model-value="service.fee"
                            label="Precio de servicio"
                            readonly
                            :rules="[validators.required]"
                          >
                            <template #prependInner>
                              <span class="px-0 font-bold text-sm">S/</span>
                            </template>
                          </VaInput>
                        </div> -->

                        <div>
                          <VaInput
                            class="mt-2 font-bold cursor-not-allowed"
                            background="#c2d2f3"
                            :model-value="service.totalExpenses"
                            label="Viáticos"
                            readonly
                            :rules="[validators.required]"
                          >
                            <template #prependInner>
                              <span class="px-0 font-bold text-sm">S/</span>
                            </template>
                          </VaInput>
                        </div>

                        <div>
                          <VaInput
                            class="mt-2 font-bold cursor-not-allowed"
                            background="#c2d2f3"
                            :model-value="service.totalVehicles"
                            label="Tarifa vehiculos"
                            readonly
                            :rules="[validators.required]"
                          >
                            <template #prependInner>
                              <span class="px-0 font-bold text-sm">S/</span>
                            </template>
                          </VaInput>
                        </div>

                        <div>
                          <VaInput
                            class="mt-2 font-bold cursor-not-allowed"
                            background="#c2d2f3"
                            :model-value="service.tollsamount"
                            label="Costo peajes"
                            readonly
                            :rules="[validators.required]"
                          >
                            <template #prependInner>
                              <span class="px-0 font-bold text-sm">S/</span>
                            </template>
                          </VaInput>
                        </div>

                        <div>
                          <VaInput
                            v-model="service.total"
                            class="mt-2 font-bold"
                            background="primary"
                            label="Precio final"
                            :rules="[validators.required]"
                          >
                            <template #prependInner>
                              <span class="px-0 font-bold text-sm">S/</span>
                            </template>
                          </VaInput>
                        </div>
                      </div>
                    </div>

                    <div v-if="service.activeDetailtab === 'Vehiculos'" class="p-2 bg-white rounded">
                      <div v-for="(vehicle, index) in service.selectedVehicles" :key="index" class="px-2 bg-gray-50">
                        <VaBadge
                          placement="top-left"
                          :text="'#' + (index + 1)"
                          overlap
                          color="primary"
                          :offset="[-10, -10]"
                        />
                        <div class="columns-1 pt-2">
                          <VaInput
                            :model-value="vehicle.name"
                            class="cursor-not-allowed"
                            label="Tipo de vehiculo"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            readonly
                          />
                        </div>

                        <div class="columns-1 mt-2">
                          <VaSelect
                            v-model="vehicle.driver"
                            class="driver-select w-full text-xs cursor-not-allowed"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            label="Tipo de conductor"
                            no-options-text="-- No hay items --"
                            :options="drivers"
                            readonly
                            value-by="id"
                            text-by="type"
                            placeholder="Selecciona un tipo"
                          />
                        </div>
                        <div class="columns-4 pt-2 pb-2">
                          <!-- <div>
                            <VaInput
                              :model-value="vehicle.quantity"
                              class="cursor-not-allowed"
                              label="Unidades"
                              background="#eee"
                              style="--va-input-wrapper-border-color: transparent"
                              readonly
                            />
                          </div> -->
                          <template v-if="vehicle.withDriver && vehicle.driver?.fee">
                            <div>
                              <VaInput
                                :model-value="vehicle.driver?.fee_time"
                                label="Horas conductor"
                                background="#eee"
                                style="--va-input-wrapper-border-color: transparent"
                                class="cursor-not-allowed"
                                readonly
                              />
                            </div>
                            <div>
                              <VaInput
                                :model-value="vehicle.driver?.feetotal"
                                label="Tarifa conductor"
                                background="#eee"
                                style="--va-input-wrapper-border-color: transparent"
                                class="cursor-not-allowed"
                                readonly
                              />
                            </div>
                          </template>

                          <div>
                            <VaInput
                              :model-value="vehicle.fee_total_perdays"
                              class="cursor-not-allowed"
                              label="Tarifa vehiculo"
                              background="#eee"
                              style="--va-input-wrapper-border-color: transparent"
                              readonly
                            />
                          </div>
                          <div>
                            <VaInput
                              :model-value="totalFeePerVehicle(vehicle)"
                              label="Tarifa total"
                              class="cursor-not-allowed"
                              background="primary"
                              style="--va-input-wrapper-border-color: transparent"
                              readonly
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="service.activeDetailtab === 'Viáticos'" class="p-2 bg-white rounded">
                      <div v-for="(expense, index) in service.selectedExpenses" :key="index" class="px-2 bg-gray-50">
                        <VaBadge
                          placement="top-left"
                          :text="'#' + (index + 1)"
                          overlap
                          color="primary"
                          :offset="[-10, -10]"
                        />
                        <div class="columns-4 pt-2 pb-2">
                          <div>
                            <VaInput
                              :model-value="expense.name"
                              class="cursor-not-allowed"
                              label="Tipo de viático"
                              background="#eee"
                              style="--va-input-wrapper-border-color: transparent"
                              readonly
                            />
                          </div>
                          <div>
                            <VaInput
                              :model-value="expense.quantity"
                              class="cursor-not-allowed"
                              label="Cantidad"
                              background="#eee"
                              style="--va-input-wrapper-border-color: transparent"
                              readonly
                            />
                          </div>
                          <div>
                            <VaInput
                              :model-value="totalFeePerExpense(expense)"
                              label="Monto asignado"
                              class="cursor-not-allowed"
                              background="primary"
                              style="--va-input-wrapper-border-color: transparent"
                              readonly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </VaCollapse>
            </div>
          </section>

          <div class="flex mb-3 gap-3 justify-end mt-4">
            <div class="w-1/5">
              <div class="flex flex-wrap gap-3">
                <VaInput
                  class="cursor-not-allowed"
                  :model-value="subTotalQuotation"
                  label="Sub total"
                  background="#eee"
                  readonly
                >
                  <template #prependInner>
                    <span class="px-0 font-bold text-sm">S/</span>
                  </template>
                </VaInput>
              </div>
            </div>
            <div class="w-1/5">
              <VaInput
                class="cursor-not-allowed"
                :model-value="igvQuotation"
                label="IGV (18%)"
                background="info"
                readonly
              >
                <template #prependInner>
                  <span class="px-0 font-bold text-sm">S/</span>
                </template>
              </VaInput>
            </div>
            <div class="w-1/5">
              <VaInput
                label="Monto Total"
                :model-value="totalQuotation"
                class="cursor-not-allowed"
                background="primary"
                readonly
              >
                <template #prependInner>
                  <span class="px-0 font-bold text-sm">S/</span>
                </template>
              </VaInput>
            </div>
          </div>

          <div class="flex mb-6 gap-3 justify-end">
            <div class="w-[170px] -mr-8">
              <div class="flex flex-wrap gap-3">
                <VaInput
                  v-model="discountValue"
                  label="Descuento"
                  clearable
                  background="#fff"
                  @update:modelValue="updateWithDiscount()"
                >
                  <template #prependInner>
                    <span class="px-0 font-bold text-sm">S/</span>
                  </template>

                  <template #appendInner>
                    <span class="flex text-xxs text-primary font-semibold">
                      Todo
                      <VaIcon
                        name="mintmark"
                        class="ml-1 -mr-1 cursor-pointer bg-primary hover:bg-success text-white rounded"
                        color="#fff"
                        @click="
                          () => {
                            discountValue = originalSubTotalQuotation
                          }
                        "
                      />
                    </span>
                  </template>
                </VaInput>
              </div>
            </div>
            <div class="w-1/5"></div>
            <div class="w-1/5"></div>
          </div>
        </template>
        <template #controls="{ nextStep, prevStep }">
          <div class="flex justify-between w-full">
            <div class="flex gap-2 justify-between w-full">
              <div v-if="step !== 2" class="flex gap-1">
                <VaButton v-if="!quotation.status" :disabled="step === 0" @click="prevStep()"> Anterior</VaButton>
                <VaButton v-if="!quotation.status" :disabled="step === 3" @click="doNext(nextStep)">
                  Siguiente
                </VaButton>
              </div>
            </div>

            <div v-if="canSave" class="min-w-[350px] flex gap-1.5 justify-end">
              <VaButton icon="save_as" color="info" :disabled="!quotation.title" :loading="loadingQ" @click="doSave()">
                Grabar</VaButton
              >

              <VaButton
                v-if="!quotation.serie"
                icon="prompt_suggestion"
                color="success"
                :disabled="!quotation.id"
                @click="doGenerateQuotation()"
              >
                Generar Cotización
              </VaButton>

              <!-- <VaButton
                v-if="!_noedit && quotation.status"
                :disabled="errors.length"
                class="pr-0.5"
                @click="confirmProcess = true"
              >
                <VaIcon name="save" class="material-symbols-outlined cursor-pointer mr-1" />
                {{ props.data ? 'Actualizar Cotización' : 'Crear Cotización' }}
              </VaButton>

              <VaButton v-if="_noedit" :disabled="errors.length" class="pr-0.5" @click="confirmProcess = true">
                <VaIcon name="save" class="material-symbols-outlined cursor-pointer mr-1" />
                Actualizar Cotización
              </VaButton> -->
            </div>
          </div>
        </template>
      </VaStepper>

      <div v-if="quotation.status === 4 && activeDetailTab === 0" class="section-detail">
        <section class="bg-blue-50 px-3 py-4">
          <div class="mb-5">
            <VaCollapse
              v-if="selectedContacts.length && false"
              v-model="clientsOpen"
              class="min-w-96 mb-2"
              style="--va-background-border: transparent"
              header="Contactos"
              solid
              color="primary"
            >
              <div class="px-2 mt-2">
                <div v-for="(contact, index) in selectedContacts" :key="index" class="bg-white px-3 mb-1 relative">
                  <VaBadge
                    placement="top-left"
                    :text="'#' + (index + 1)"
                    overlap
                    color="primary"
                    class="absolute"
                    :offset="[-10, -10]"
                  />
                  <div class="columns-3 pt-6 py-3">
                    <div>
                      <VaInput
                        :model-value="contact.fullname"
                        label="Nombre de cliente"
                        background="#fff"
                        readonly
                        class="cursor-not-allowed"
                        placeholder="ej: Jr Malaga 200"
                      />
                    </div>
                    <div>
                      <VaInput
                        :model-value="contact.cellphone"
                        label="Teléfono"
                        background="#fff"
                        readonly
                        class="cursor-not-allowed"
                        placeholder="ej: Jr Malaga 200"
                      />
                    </div>
                    <div>
                      <VaInput
                        :model-value="contact.document"
                        label="Documento"
                        background="#fff"
                        readonly
                        class="cursor-not-allowed"
                        placeholder="ej: Jr Malaga 200"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </VaCollapse>

            <div class="px-3.5 mb-4 mt-2">
              <div v-for="(contact, index) in selectedContacts" :key="index" class="bg-white px-3 mb-1 relative">
                <div v-if="!contact.withCustomer" class="columns-3 py-3">
                  <div>
                    <VaInput
                      :model-value="contact.fullname"
                      label="Nombre de cliente"
                      background="#d5e3ff"
                      readonly
                      class="cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <VaInput
                      :model-value="contact.cellphone"
                      label="Teléfono"
                      background="#d5e3ff"
                      readonly
                      class="cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <VaInput
                      :model-value="contact.document"
                      label="Documento"
                      background="#d5e3ff"
                      readonly
                      class="cursor-not-allowed"
                    />
                  </div>
                </div>

                <div v-if="contact.withCustomer" class="columns-3 py-3">
                  <div>
                    <VaInput
                      :model-value="contact.company?.socialreason"
                      label="Razón Social"
                      background="#d5e3ff"
                      readonly
                      class="cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <VaInput
                      :model-value="contact.company?.ruc"
                      label="RUC"
                      background="#d5e3ff"
                      readonly
                      class="cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <VaInput
                      :model-value="contact.company?.phone"
                      label="Teléfono"
                      background="#d5e3ff"
                      readonly
                      class="cursor-not-allowed"
                    />
                  </div>
                </div>
              </div>
            </div>

            <VaCollapse
              v-if="selectedServices.length"
              v-model="servicesOpen"
              class="min-w-96"
              style="--va-background-border: transparent"
              header="Servicios"
              solid
              color="primary"
            >
              <div class="px-2 mt-2">
                <div v-for="(service, index) in selectedServices" :key="index" class="bg-white px-3 mt-3 pb-3 relative">
                  <VaBadge
                    placement="top-left"
                    :text="'#' + (index + 1)"
                    overlap
                    class="absolute"
                    color="primary"
                    :offset="[-10, -10]"
                  />

                  <VaTabs v-model="service.activeDetailtab" stateful grow class="mb-3">
                    <template #tabs>
                      <VaTab v-for="title in ['Servicio', 'Vehiculos', 'Viáticos']" :key="title" :name="title">
                        {{ title }}
                        <VaBadge
                          v-if="service.selectedVehicles.length && title === 'Vehiculos'"
                          placement="top"
                          :text="service.selectedVehicles.length"
                          overlap
                          color="primary"
                          rounded
                          :offset="[-50, -10]"
                          class="ml-2 cursor-not-allowed"
                          style="--va-badge-text-wrapper-border-radius: 50%"
                        />

                        <VaBadge
                          v-if="service.selectedExpenses.length && title === 'Viáticos'"
                          placement="top"
                          :text="service.selectedExpenses.length"
                          overlap
                          color="primary"
                          rounded
                          :offset="[-50, -10]"
                          class="ml-2 cursor-not-allowed"
                          style="--va-badge-text-wrapper-border-radius: 50%"
                        />
                      </VaTab>
                    </template>
                  </VaTabs>

                  <div v-if="service.activeDetailtab === 'Servicio'" class="px-2 bg-white rounded">
                    <div class="flex gap-4 pr-3 pt-3">
                      <div class="w-1/2">
                        <VaSelect
                          v-model="service.id"
                          class="w-full mb-3 text-xs cursor-not-allowed"
                          background="#d5e3ff"
                          readonly
                          label="Tipo de servicio"
                          no-options-text="-- No hay items --"
                          :options="services"
                          value-by="id"
                          text-by="service"
                          placeholder="---"
                        />
                      </div>

                      <template v-if="service.withroute && !service._route">
                        <div class="w-1/4">
                          <VaInput
                            :model-value="service.serviceDetail.addressfrom"
                            label="Origen"
                            class="cursor-not-allowed"
                            style="--va-input-wrapper-border-color: transparent"
                            background="#eee"
                            readonly
                          />
                        </div>
                        <div class="w-1/4">
                          <VaInput
                            :model-value="service.serviceDetail.addressto"
                            label="Destino"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            class="cursor-not-allowed"
                            readonly
                          />
                        </div>
                      </template>
                    </div>
                    <div v-if="service.withroute && !service._route" class="columns-4 py-1 pb-2">
                      <div>
                        <VaInput
                          :model-value="service.serviceDetail.kilometers"
                          label="Kilometros"
                          background="#eee"
                          style="--va-input-wrapper-border-color: transparent"
                          class="cursor-not-allowed"
                          readonly
                        />
                      </div>
                      <!-- <div>
                          <VaInput
                            :model-value="service.serviceDetail.traveldays"
                            label="Dias de viaje"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            readonly
                            class="cursor-not-allowed"
                          />
                        </div> -->
                      <div>
                        <VaInput
                          :model-value="service.serviceDetail.tollsFrom"
                          label="Peajes (Ida)"
                          background="#eee"
                          style="--va-input-wrapper-border-color: transparent"
                          class="cursor-not-allowed"
                          readonly
                        />
                      </div>
                      <div>
                        <VaInput
                          :model-value="service.serviceDetail.tollsTo"
                          label="Peajes (Vuelta)"
                          background="#eee"
                          style="--va-input-wrapper-border-color: transparent"
                          class="cursor-not-allowed"
                          readonly
                        />
                      </div>
                      <!-- <div>
                        <VaInput
                          :model-value="service.serviceDetail.passengers"
                          label="Pasajeros"
                          background="#eee"
                          style="--va-input-wrapper-border-color: transparent"
                          class="cursor-not-allowed"
                          readonly
                        />
                      </div> -->
                    </div>

                    <div v-if="service.withroute && service._route" class="columns-2">
                      <div>
                        <VaSelect
                          v-model="service._route"
                          background="#d5e3ff"
                          readonly
                          label="Ruta seleccionada"
                          no-options-text="-- No hay items --"
                          :options="routes"
                          value-by="id"
                          searchable
                          search-placeholder-text="Buscar ruta"
                          text-by="name"
                          placeholder="---"
                          class="w-full text-xs cursor-not-allowed"
                          style="--va-input-wrapper-border-color: transparent"
                        >
                          <template #option="{ option, selectOption }">
                            <div
                              class="font-bold text-xs px-1 py-0.5 hover:bg-primary cursor-pointer hover:text-white"
                              @click="selectOption(option)"
                            >
                              {{ option?.name }}
                            </div>
                          </template>
                        </VaSelect>
                      </div>
                    </div>
                    <div v-if="service.withroute && service._route" class="columns-3 py-1 pb-2 pt-3">
                      <div>
                        <VaSelect
                          v-model="service._routetype"
                          background="#d5e3ff"
                          no-options-text="-- No hay items --"
                          readonly
                          label="Tipo de ruta"
                          :options="types"
                          value-by="id"
                          text-by="label"
                          placeholder="---"
                          class="w-full text-xs cursor-not-allowed"
                          style="--va-input-wrapper-border-color: transparent"
                        />
                      </div>

                      <!-- <div>
                        <VaInput
                          :model-value="_routeSelected(service._route)?.kilometers"
                          label="Kilometros"
                          min="0"
                          class="cursor-not-allowed"
                          style="--va-input-wrapper-border-color: transparent"
                          background="#eee"
                          readonly
                          type="number"
                        />
                      </div> -->
                      <!-- <div class="flex">
                        <VaInput
                          v-model="service.serviceDetail.passengers"
                          class="cursor-not-allowed"
                          style="--va-input-wrapper-border-color: transparent"
                          label="Pasajeros"
                          background="#eee"
                          readonly
                          min="0"
                          type="number"
                        />
                      </div> -->
                    </div>

                    <div v-if="service.serviceDetail.withdate" class="columns-4 mt-1 pb-3">
                      <div>
                        <!-- <VaDateInput
                          v-model="service.serviceDetail.startdate"
                          background="#eee"
                          label="Fecha de inicio"
                          style="--va-input-wrapper-border-color: transparent"
                          class="cursor-not-allowed"
                          readonly
                        /> -->
                        <VaDateInput
                          v-model="service.serviceDetail.date"
                          mode="single"
                          background="#fff"
                          label="Fecha del servicio"
                          :format-date="formatFn"
                          :rules="[validators.required]"
                          class="w-full"
                          @update:modelValue="
                            () => {
                              updateTotal(service)
                            }
                          "
                        />
                      </div>
                      <div v-if="service.serviceDetail.starttime">
                        <VaTimeInput
                          v-model="service.serviceDetail.starttime"
                          background="#eee"
                          label="Hora Inicio"
                          style="--va-input-wrapper-border-color: transparent"
                          class="cursor-not-allowed"
                          ampm
                          readonly
                        />
                      </div>
                      <!-- <div>
                        <VaDateInput
                          v-model="service.serviceDetail.enddate"
                          background="#eee"
                          label="Fecha de fin"
                          class="cursor-not-allowed"
                          style="--va-input-wrapper-border-color: transparent"
                          readonly
                        />
                      </div> -->
                      <div v-if="service.serviceDetail.endtime">
                        <VaTimeInput
                          v-model="service.serviceDetail.endtime"
                          background="#eee"
                          label="Hora Fin"
                          style="--va-input-wrapper-border-color: transparent"
                          class="cursor-not-allowed"
                          ampm
                          readonly
                        />
                      </div>
                    </div>

                    <div class="columns-1">
                      <div class="mb-5">
                        <p style="font-size: 10.5px; font-weight: 600; color: var(--va-primary)">
                          Condiciones Especificas:
                        </p>
                        <QuillEditor
                          v-model:content="service.specifications"
                          theme="snow"
                          content-type="html"
                          :toolbar="['bold', 'italic']"
                        />
                      </div>
                    </div>

                    <div class="columns-5 pb-4">
                      <!-- <div>
                        <VaInput
                          class="mt-2 font-bold cursor-not-allowed"
                          background="#c2d2f3"
                          :model-value="service.fee"
                          label="Precio de servicio"
                          readonly
                          :rules="[validators.required]"
                        >
                          <template #prependInner>
                            <span class="px-0 font-bold text-sm">S/</span>
                          </template>
                        </VaInput>
                      </div> -->

                      <div>
                        <VaInput
                          class="mt-2 font-bold cursor-not-allowed"
                          background="#c2d2f3"
                          :model-value="service.totalExpenses"
                          label="Viáticos"
                          readonly
                          :rules="[validators.required]"
                        >
                          <template #prependInner>
                            <span class="px-0 font-bold text-sm">S/</span>
                          </template>
                        </VaInput>
                      </div>

                      <div>
                        <VaInput
                          class="mt-2 font-bold cursor-not-allowed"
                          background="#c2d2f3"
                          :model-value="service.totalVehicles"
                          label="Tarifa vehiculos"
                          readonly
                          :rules="[validators.required]"
                        >
                          <template #prependInner>
                            <span class="px-0 font-bold text-sm">S/</span>
                          </template>
                        </VaInput>
                      </div>

                      <div>
                        <VaInput
                          class="mt-2 font-bold cursor-not-allowed"
                          background="#c2d2f3"
                          :model-value="service.tollsamount"
                          label="Costo peajes"
                          readonly
                          :rules="[validators.required]"
                        >
                          <template #prependInner>
                            <span class="px-0 font-bold text-sm">S/</span>
                          </template>
                        </VaInput>
                      </div>

                      <div>
                        <VaInput
                          v-model="service.total"
                          class="mt-2 font-bold"
                          background="primary"
                          label="Precio final"
                          :rules="[validators.required]"
                        >
                          <template #prependInner>
                            <span class="px-0 font-bold text-sm">S/</span>
                          </template>
                        </VaInput>
                      </div>
                    </div>
                  </div>

                  <div v-if="service.activeDetailtab === 'Vehiculos'" class="p-2 bg-white rounded">
                    <div v-for="(vehicle, index) in service.selectedVehicles" :key="index" class="px-2 bg-gray-50">
                      <VaBadge
                        placement="top-left"
                        :text="'#' + (index + 1)"
                        overlap
                        color="primary"
                        :offset="[-10, -10]"
                      />
                      <div class="columns-1 pt-2">
                        <VaInput
                          :model-value="vehicle.name"
                          class="cursor-not-allowed"
                          label="Tipo de vehiculo"
                          background="#eee"
                          style="--va-input-wrapper-border-color: transparent"
                          readonly
                        />
                      </div>

                      <div class="columns-1 mt-2">
                        <VaSelect
                          v-model="vehicle.driver"
                          class="driver-select w-full text-xs cursor-not-allowed"
                          background="#eee"
                          style="--va-input-wrapper-border-color: transparent"
                          label="Tipo de conductor"
                          :options="drivers"
                          readonly
                          no-options-text="-- No hay items --"
                          value-by="id"
                          text-by="type"
                          placeholder="Selecciona un tipo"
                        />
                      </div>
                      <div class="columns-4 pt-2 pb-2">
                        <!-- <div>
                          <VaInput
                            :model-value="vehicle.quantity"
                            class="cursor-not-allowed"
                            label="Unidades"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            readonly
                          />
                        </div> -->
                        <template v-if="vehicle.withDriver && vehicle.driver?.fee">
                          <div>
                            <VaInput
                              :model-value="vehicle.driver?.fee"
                              label="Trf conductor (x Hora)"
                              background="#eee"
                              style="--va-input-wrapper-border-color: transparent"
                              class="cursor-not-allowed"
                              readonly
                            />
                          </div>
                        </template>
                        <div>
                          <!--  (x Día) -->
                          <VaInput
                            :model-value="vehicle.fee"
                            class="cursor-not-allowed"
                            label="Trf vehiculo"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            readonly
                          />
                        </div>
                        <div>
                          <VaInput
                            :model-value="totalFeePerVehicle(vehicle)"
                            label="Tarifa total"
                            class="cursor-not-allowed"
                            background="primary"
                            style="--va-input-wrapper-border-color: transparent"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="service.activeDetailtab === 'Viáticos'" class="p-2 bg-white rounded">
                    <div v-for="(expense, index) in service.selectedExpenses" :key="index" class="px-2 bg-gray-50">
                      <VaBadge
                        placement="top-left"
                        :text="'#' + (index + 1)"
                        overlap
                        color="primary"
                        :offset="[-10, -10]"
                      />
                      <div class="columns-4 pt-2 pb-2">
                        <div>
                          <VaInput
                            :model-value="expense.name"
                            class="cursor-not-allowed"
                            label="Tipo de viático"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            readonly
                          />
                        </div>
                        <!-- <div>
                          <VaInput
                            :model-value="expense.quantity"
                            class="cursor-not-allowed"
                            label="Cantidad"
                            background="#eee"
                            style="--va-input-wrapper-border-color: transparent"
                            readonly
                          />
                        </div> -->
                        <div>
                          <VaInput
                            :model-value="totalFeePerExpense(expense)"
                            label="Monto asignado"
                            class="cursor-not-allowed"
                            background="primary"
                            style="--va-input-wrapper-border-color: transparent"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VaCollapse>
          </div>
        </section>

        <VaModal v-model="showNewContract" hide-default-actions size="700px" close-button blur no-dismiss>
          <div>
            <NewContract
              :id="quotation.id"
              @close="
                () => {
                  showNewContract = false
                }
              "
            />
          </div>
        </VaModal>

        <div class="flex mb-2 gap-3 justify-end mt-4">
          <div class="w-1/5">
            <VaInput
              class="cursor-not-allowed"
              :model-value="subTotalQuotation"
              label="Sub total"
              background="#eee"
              readonly
            >
              <template #prependInner>
                <span class="px-0 font-bold text-sm">S/</span>
              </template>
            </VaInput>
          </div>
          <div class="w-1/5">
            <VaInput
              class="cursor-not-allowed"
              :model-value="igvQuotation"
              label="IGV (18%)"
              background="#eee"
              readonly
            >
              <template #prependInner>
                <span class="px-0 font-bold text-sm">S/</span>
              </template>
            </VaInput>
          </div>
          <div class="w-1/5">
            <VaInput
              label="Monto Total"
              :model-value="totalQuotation"
              class="cursor-not-allowed"
              background="#eee"
              readonly
            >
              <template #prependInner>
                <span class="px-0 font-bold text-sm">S/</span>
              </template>
            </VaInput>
          </div>
        </div>

        <div class="flex mb-2 gap-3 justify-end">
          <div class="w-1/5">
            <VaInput
              label="Descuento"
              :model-value="quotation.discount"
              class="cursor-not-allowed"
              background="info"
              readonly
            >
              <template #prependInner>
                <span class="px-0 font-bold text-sm">S/</span>
              </template>
            </VaInput>
          </div>
        </div>

        <div class="flex mb-6 gap-3 justify-end">
          <div class="w-1/5">
            <VaInput
              label="Monto Aprobado"
              :model-value="quotation.final_price"
              class="cursor-not-allowed"
              background="primary"
              readonly
            >
              <template #prependInner>
                <span class="px-0 font-bold text-sm">S/</span>
              </template>
            </VaInput>
          </div>
        </div>
      </div>

      <div v-if="activeDetailTab === 1">
        <div class="h-full">
          <Interactions :data="props.data" />
        </div>
      </div>

      <div v-if="activeDetailTab === 2">
        <div style="background: #d5e3ff" class="p-3 pt-3 pb-4">
          <div class="w-full gap-3">
            <VaInput :model-value="contract.title" label="Titulo de Contrato" background="#fff">
              <template #prepend>
                <p class="pr-3 font-bold text-sm">#{{ contract.id }}</p>
              </template>

              <template #append>
                <div class="px-2">
                  <VaButton icon="open_in_new" color="primary" round @click="openNewContract()"></VaButton>
                </div>
              </template>
            </VaInput>
          </div>
          <!-- <div class="w-full columns-3 mb-6 gap-3 justify-end mt-4">
            <div class="">
              <div class="flex flex-wrap gap-3">
                <VaInput :model-value="contract.effective_at" label="Fec. Ejecución" background="#fff"> </VaInput>
              </div>

              <div class="flex flex-wrap gap-3">
                <VaInput :model-value="contract.payment_deadline" label="Fec. de Pago" background="#fff"> </VaInput>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <VaModal v-model="showNewCustomer" hide-default-actions size="medium" close-button blur no-dismiss>
      <div class="mt-4">
        <NewCustomer @close="closeViewCustomer" />
      </div>
    </VaModal>

    <VaModal v-model="showNewRoute" size="700px" close-button hide-default-actions no-dismiss blur>
      <div>
        <NewRoute
          @close="
            () => {
              showNewRoute = false
              getAllRoutes$()
            }
          "
        />
      </div>
    </VaModal>

    <VaModal v-model="showViewCustomer" hide-default-actions size="medium" close-button blur no-dismiss>
      <div class="mt-4">
        <EditCustomer :id="contactSelected" @close="closeViewCustomer" />
      </div>
    </VaModal>

    <VaModal v-model="showNewComment" hide-default-actions size="450px" close-button blur no-dismiss>
      <div class="mt-4">
        <NewComment :data="props.data" @close="closeNewComment" />
      </div>
    </VaModal>

    <VaModal v-model="showConfirm" size="250px" hide-default-actions no-dismiss blur>
      <p class="text-sm">¿Deseas eliminar el servicio?</p>

      <template #footer>
        <VaButton size="small" preset="secondary" class="mr-1" @click="needConfirm(null)"> Cancelar</VaButton>
        <VaButton size="small" @click="doDelete"> Continuar</VaButton>
      </template>
    </VaModal>

    <VaModal v-model="showViewContract" hide-default-actions size="600px" close-button blur no-dismiss>
      <div>
        <ViewContract
          :id="contractId"
          @close="
            () => {
              showViewContract = false
            }
          "
        />
      </div>
    </VaModal>

    <VaModal v-model="confirmProcess" size="300px" hide-default-actions no-dismiss blur>
      <p v-if="!_noedit" class="text-sm">¿Deseas registrar esta cotización?</p>
      <p v-if="_noedit" class="text-sm">¿Deseas actualizar la cotización?</p>

      <div v-if="errors.length" class="my-4 bg-red-50 px-2 py-1">
        <h4 class="text-sm font-bold">Hay errores:</h4>

        <ul class="text-xs py-2 text-red-800 font-bold list-decimal pl-3.5">
          <li v-for="i in errors" :key="i">{{ i }}</li>
        </ul>
      </div>

      <template #footer>
        <VaButton size="small" preset="secondary" :disabled="loadingQ" class="mr-1" @click="closeProcess()">
          Cancelar
        </VaButton>
        <VaButton size="small" :loading="loadingQ" @click="doCreate()"> Continuar</VaButton>
      </template>
    </VaModal>
  </div>

  <VaSkeletonGroup v-if="loadingData" color="#eff6ff" animation="wave" class="mb-5">
    <VaCard class="mb-5" :square="true">
      <VaCardContent>
        <VaSkeleton variant="squared" height="50px" />
      </VaCardContent>
    </VaCard>

    <VaCard :square="true">
      <VaCardContent class="flex items-center mb-3 gap-3">
        <VaSkeleton variant="squared" height="30px" />
        <VaSkeleton variant="squared" height="30px" />
        <VaSkeleton variant="squared" height="30px" />
      </VaCardContent>
      <VaCardContent>
        <VaSkeleton variant="squared" height="200px" />
      </VaCardContent>
      <VaCardActions class="flex">
        <VaSkeleton class="mr-2" variant="rounded" inline width="64px" height="32px" />
        <VaSkeleton variant="rounded" inline width="64px" height="32px" />
      </VaCardActions>
    </VaCard>
  </VaSkeletonGroup>
</template>

<style lang="scss">
.va-stepper__step-button {
  font-size: 12px;
}

.va-stepper__step-button__icon {
  .va-icon.va-icon {
    font-size: 1.1rem !important;
    height: 1.3rem !important;
  }
}

.button-new {
  height: fit-content;
  margin-top: 1.4rem;
}

.new-stepper section {
  min-height: 250px;

  .vehicle-type {
    background-color: rgb(239 246 255 / var(--tw-bg-opacity)) !important;

    .driver-select {
      .va-input-wrapper__size-keeper {
        width: 100%;
      }
    }
  }
}

.no-padding {
  .va-input-wrapper__field {
    padding: 3px 9px !important;
  }
}

.check-type {
  .va-switch__label {
    font-size: 11px;
    font-weight: 600;
  }
}
</style>
